
// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { doc, getDoc, setDoc, updateDoc, deleteField, collection, getDocs, query, where } from 'firebase/firestore';
// import { db, auth } from '../../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import './Cart.css';

// const Cart = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [userId, setUserId] = useState(null);
//   const [orders, setOrders] = useState([]);
//   const [loadingOrders, setLoadingOrders] = useState(true);
//   const [isOrderHistoryExpanded, setIsOrderHistoryExpanded] = useState(false);
  
//   // Error state
//   const [orderError, setOrderError] = useState(null);
//   const [userData, setUserData] = useState(null);
  
//   // Points and coupon states
//   const [usePointsDiscount, setUsePointsDiscount] = useState(false);
//   const [pointsDiscountAmount, setPointsDiscountAmount] = useState(0);
//   const [availablePoints, setAvailablePoints] = useState(0);
//   const [pointsMessage, setPointsMessage] = useState('');
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [discountAmount, setDiscountAmount] = useState(0);
  
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Normalize delivery speed values
//   const normalizeDeliverySpeed = (speed) => {
//     if (!speed) return 'normal';
//     const speedLower = typeof speed === 'string' ? speed.toLowerCase() : 'normal';
//     if (speedLower.includes('express') || speedLower.includes('quick')) {
//       return 'quick';
//     } else if (speedLower.includes('late')) {
//       return 'late';
//     } else {
//       return 'normal';
//     }
//   };

//   // Calculate delivery surcharge based on original and current delivery speed
//   const calculateDeliverySurcharge = (originalSpeed, currentSpeed) => {
//     if (originalSpeed === currentSpeed) {
//       return 0;
//     }
//     if (originalSpeed === 'quick') {
//       return 0;
//     } else if (originalSpeed === 'normal' || originalSpeed === 'standard') {
//       if (currentSpeed === 'quick') {
//         return 80;
//       }
//       return 0;
//     } else if (originalSpeed === 'late') {
//       if (currentSpeed === 'quick') {
//         return 80;
//       } else if (currentSpeed === 'normal' || currentSpeed === 'standard') {
//         return 60;
//       }
//     }
//     return 0;
//   };

//   // Fetch cart from Firestore (memoized)
//   const fetchCartFromFirestore = useCallback(async (uid) => {
//     try {
//       console.log("Fetching cart from Firestore for user:", uid);
//       const cartDocRef = doc(db, 'carts', uid);
//       const cartDoc = await getDoc(cartDocRef);
//       if (cartDoc.exists()) {
//         const cartData = cartDoc.data();
//         console.log("Firestore cart data:", cartData);
//         if (cartData.items && Object.keys(cartData.items).length > 0) {
//           const cartItemsArray = Object.values(cartData.items || {});
//           console.log("Firestore cart items array:", cartItemsArray);
//           const validItems = cartItemsArray
//             .filter(item => {
//               console.log("Cart item before validation:", item);
//               const isValid = item && item.id && item.name && item.price;
//               if (!isValid) {
//                 console.log("Invalid item found:", item);
//                 console.log("Missing properties:", {
//                   hasItem: !!item,
//                   hasId: item && !!item.id,
//                   hasName: item && !!item.name,
//                   hasPrice: item && !!item.price
//                 });
//               }
//               return isValid;
//             })
//             .map(item => {
//               const normalizedDeliverySpeed = normalizeDeliverySpeed(item.deliverySpeed);
//               const normalizedOriginalSpeed = item.originalDeliverySpeed ?
//                 normalizeDeliverySpeed(item.originalDeliverySpeed) :
//                 normalizedDeliverySpeed;
//               return {
//                 ...item,
//                 quantity: item.quantity || 1,
//                 deliverySpeed: normalizedDeliverySpeed,
//                 originalDeliverySpeed: normalizedOriginalSpeed,
//                 deliverySurcharge: calculateDeliverySurcharge(normalizedOriginalSpeed, normalizedDeliverySpeed),
//                 couponApplied: item.couponApplied || false,
//                 pointsDiscount: item.pointsDiscount || 0,
//                 pointsUsed: item.pointsUsed || 0
//               };
//             });
//           console.log("Loaded items from Firestore:", validItems);
//           if (validItems.length > 0) {
//             setCartItems(validItems);
//             localStorage.setItem('cartItems', JSON.stringify(validItems));
//             console.log("Updated cart with Firestore items:", validItems.length);
            
//             // Check if points discount was applied
//             const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
//             if (anyPointsUsed) {
//               setUsePointsDiscount(true);
//             }
            
//             // Check if coupon was applied
//             const anyCouponApplied = validItems.some(item => item.couponApplied);
//             setCouponApplied(anyCouponApplied);
//           } else {
//             console.log("No valid items found in Firestore, checking localStorage");
//             fetchCartFromLocalStorage();
//           }
//         } else {
//           console.log("No items in Firestore cart, checking localStorage");
//           fetchCartFromLocalStorage();
//         }
//       } else {
//         console.log("Cart document does not exist in Firestore, checking localStorage");
//         fetchCartFromLocalStorage();
//       }
//     } catch (error) {
//       console.error('Error fetching cart from Firestore:', error);
//       fetchCartFromLocalStorage();
//     }
//   }, []);

//   // Fetch cart from localStorage (memoized)
//   const fetchCartFromLocalStorage = useCallback(() => {
//     console.log("Fetching cart from localStorage");
//     const storedCart = localStorage.getItem('cartItems');
//     console.log("Raw localStorage cartItems:", storedCart);
    
//     if (storedCart) {
//       try {
//         const parsedCart = JSON.parse(storedCart);
//         console.log("Parsed localStorage cartItems:", parsedCart);
//         let itemsToProcess = parsedCart;
//         if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
//           console.log("Found items property in localStorage cart object");
//           itemsToProcess = parsedCart.items;
//         }
//         if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
//           console.log("Converting object to array from localStorage");
//           itemsToProcess = Object.values(itemsToProcess);
//         }
//         if (!Array.isArray(itemsToProcess)) {
//           console.log("itemsToProcess is not an array, setting to empty array");
//           itemsToProcess = [];
//         }
//         const validItems = itemsToProcess
//           .filter(item => {
//             console.log("Cart item before validation:", item);
//             const isValid = item && item.id && item.name;
//             if (!isValid) {
//               console.log("Invalid item found:", item);
//               console.log("Missing properties:", {
//                 hasItem: !!item,
//                 hasId: item && !!item.id,
//                 hasName: item && !!item.name
//               });
//             }
//             return isValid;
//           })
//           .map(item => {
//             const normalizedDeliverySpeed = normalizeDeliverySpeed(item.deliverySpeed);
//             const normalizedOriginalSpeed = item.originalDeliverySpeed ?
//               normalizeDeliverySpeed(item.originalDeliverySpeed) :
//               normalizedDeliverySpeed;
//             return {
//               ...item,
//               price: item.price || 0,
//               originalPrice: item.originalPrice || item.price || 0, // Ensure originalPrice exists
//               quantity: item.quantity || 1,
//               deliverySpeed: normalizedDeliverySpeed,
//               originalDeliverySpeed: normalizedOriginalSpeed,
//               deliverySurcharge: calculateDeliverySurcharge(normalizedOriginalSpeed, normalizedDeliverySpeed),
//               couponApplied: item.couponApplied || false,
//               pointsDiscount: item.pointsDiscount || 0,
//               pointsUsed: item.pointsUsed || 0
//             };
//           });
//         console.log("Loaded items from localStorage:", validItems);
//         console.log("Valid items count:", validItems.length);
//         if (validItems.length > 0) {
//           setCartItems(validItems);
//           localStorage.setItem('cartItems', JSON.stringify(validItems));
//           console.log("Updated localStorage with normalized items");
          
//           // Check if points discount was applied
//           const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
//           if (anyPointsUsed) {
//             setUsePointsDiscount(true);
//           }
          
//           // Check if coupon was applied
//           const anyCouponApplied = validItems.some(item => item.couponApplied);
//           setCouponApplied(anyCouponApplied);
//         } else {
//           console.log("No valid items found in localStorage");
//           setCartItems([]);
//         }
//       } catch (error) {
//         console.error('Error parsing cart items from localStorage:', error);
//         setCartItems([]);
//       }
//     } else {
//       console.log("No cart items in localStorage, setting to empty.");
//       setCartItems([]);
//     }
//   }, []);

//   // Fetch orders from Firestore (memoized)
//   const fetchOrdersFromFirestore = useCallback(async (uid) => {
//     setLoadingOrders(true);
//     try {
//       console.log("Fetching orders from Firestore for user:", uid);
//       const ordersCollectionRef = collection(db, 'orders');
//       const q = query(ordersCollectionRef, where('userId', '==', uid));
//       const ordersSnapshot = await getDocs(q);
//       console.log("Firestore orders snapshot empty?", ordersSnapshot.empty);
//       console.log("Number of orders fetched:", ordersSnapshot.docs.length);
//       if (ordersSnapshot.empty) {
//         console.log("No orders found for user in Firestore at path 'orders' with userId:", uid);
//         setOrders([]);
//         return;
//       }
//       const ordersList = ordersSnapshot.docs.map(doc => {
//         const data = doc.data();
//         console.log(`Order document ${doc.id} data:`, data);
//         const items = data.cartItems || data.items || data.orderItems || [];
//         const total = data.total !== undefined ? data.total : 0;
//         const status = data.status || 'pending';
//         const isValidItems = Array.isArray(items) && items.every(item => item.id && item.name);
//         if (!isValidItems) {
//           console.warn(`Order ${doc.id} has invalid or missing items:`, items);
//           return null;
//         }
//         const normalizedItems = items.map(item => ({
//           id: item.id,
//           name: item.name,
//           price: item.price || 0,
//           quantity: item.quantity || 1,
//           deliverySpeed: normalizeDeliverySpeed(item.deliverySpeed),
//           image: item.image || item.imageUrl,
//           imageUrl: item.imageUrl || item.image,
//         }));
//         const date = data.orderDate || data.date;
//         const parsedDate = date && typeof date.toDate === 'function' ? date : new Date();
//         if (!date || (typeof date.toDate !== 'function' && isNaN(new Date(date).getTime()))) {
//           console.warn(`Order ${doc.id} has invalid date field, using current date as fallback:`, date);
//         }
//         return {
//           id: doc.id,
//           items: normalizedItems,
//           total,
//           status,
//           date: parsedDate,
//         };
//       }).filter(order => order !== null);
//       console.log("Processed orders list:", ordersList);
//       if (ordersList.length === 0) {
//         console.log("No valid orders after processing. Check field names and data structure.");
//         setOrders([]);
//         return;
//       }
//       const sortedOrders = ordersList.sort((a, b) => {
//         const dateA = a.date.toDate ? a.date.toDate() : new Date(a.date);
//         const dateB = b.date.toDate ? b.date.toDate() : new Date(b.date);
//         return dateB - dateA;
//       });
//       console.log("Sorted orders:", sortedOrders);
//       setOrders(sortedOrders);
//       console.log("Orders state updated with:", sortedOrders);
//     } catch (error) {
//       console.error('Error fetching orders from Firestore:', error);
//       setOrders([]);
//     } finally {
//       setLoadingOrders(false);
//     }
//   }, []);

//   // Check authentication, load data, and handle post-checkout refresh
//   useEffect(() => {
//     console.log("Cart component mounted, checking auth state");
//     const quickCheck = localStorage.getItem('cartItems');
//     if (quickCheck) {
//       try {
//         const parsedItems = JSON.parse(quickCheck);
//         if (Array.isArray(parsedItems) && parsedItems.length > 0) {
//           console.log("Found cart items in localStorage, displaying temporarily:", parsedItems.length);
//           setCartItems(parsedItems);
//         }
//       } catch (e) {
//         console.error("Error parsing localStorage cart for quick display:", e);
//       }
//     }
//     let authInitialized = false;
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       console.log("Auth state changed:", user ? user.uid : "No user");
//       if (!authInitialized) {
//         authInitialized = true;
//         setLoading(false);
//       }
//       if (user) {
//         console.log("User is authenticated:", user.uid);
//         setUserId(user.uid);
//         fetchCartFromFirestore(user.uid);
//         fetchOrdersFromFirestore(user.uid);
        
//         // Load user data for points system
//         try {
//           const userDocRef = query(
//             collection(db, 'users'),
//             where('email', '==', user.email)
//           );
//           const userSnapshot = await getDocs(userDocRef);
//           if (!userSnapshot.empty) {
//             const userData = userSnapshot.docs[0].data();
//             const userPoints = userData.points || 0;
//             setAvailablePoints(userPoints);
//             setUserData({
//               uid: user.uid,
//               email: user.email,
//               name: userData.name || user.displayName || 'User',
//               phone: userData.phone || '',
//               deliveryAddress: userData.deliveryAddress || '',
//               points: userPoints
//             });
//           } else {
//             // Fallback to stored user data in localStorage
//             const storedUserData = localStorage.getItem('userData');
//             if (storedUserData) {
//               const parsedUserData = JSON.parse(storedUserData);
//               setUserData(parsedUserData);
//               setAvailablePoints(parsedUserData.points || 0);
//             }
//           }
//         } catch (error) {
//           console.error("Error loading user data:", error);
//         }
//       } else {
//         console.log("User is not authenticated, using localStorage");
//         setUserId(null);
//         fetchCartFromLocalStorage();
//         if (authInitialized) {
//           setOrders([]);
//           setLoadingOrders(false);
//         }
        
//         // Try to load user data from localStorage
//         const storedUserData = localStorage.getItem('userData');
//         if (storedUserData) {
//           try {
//             const parsedUserData = JSON.parse(storedUserData);
//             setUserData(parsedUserData);
//             setAvailablePoints(parsedUserData.points || 0);
//           } catch (error) {
//             console.error("Error parsing stored user data:", error);
//           }
//         }
//       }
//     });

//     // Listen for cart update events
//     const handleCartUpdate = () => {
//       console.log("Cart update event detected");
//       if (userId) {
//         fetchCartFromFirestore(userId);
//       } else {
//         fetchCartFromLocalStorage();
//       }
//     };

//     window.addEventListener('cartUpdated', handleCartUpdate);

//     return () => {
//       unsubscribe();
//       window.removeEventListener('cartUpdated', handleCartUpdate);
//     };
//   }, [fetchCartFromFirestore, fetchCartFromLocalStorage, fetchOrdersFromFirestore]);

//   // Calculate points discount and update messages
//   useEffect(() => {
//     if (cartItems && cartItems.length > 0) {
//       const baseSubtotal = calculateSubtotal();
//       const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
//       setDiscountAmount(couponDiscount);
      
//       // First check if any existing points are already applied in cart items
//       const existingPointsUsed = cartItems.reduce((total, item) => {
//         return total + (item.pointsUsed || 0);
//       }, 0);
      
//       let pointsDiscount = 0;
      
//       if (existingPointsUsed > 0) {
//         // If points are already applied, use that exact value
//         pointsDiscount = existingPointsUsed / 100;
//         setPointsMessage(`Using ${existingPointsUsed} points for ₹${pointsDiscount.toFixed(2)} discount`);
//         setUsePointsDiscount(true);
//       } else if (usePointsDiscount && availablePoints > 0) {
//         // Otherwise calculate new discount if enabled
//         // 100 points = ₹1 discount
//         const maxPointsDiscount = availablePoints / 100;
//         const maxAllowedDiscount = baseSubtotal - couponDiscount;
//         pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        
//         if (pointsDiscount > 0) {
//           setPointsMessage(`Using ${Math.floor(pointsDiscount * 100)} points for ₹${pointsDiscount.toFixed(2)} discount`);
//         } else {
//           setPointsMessage('Not enough points for discount');
//         }
//       } else {
//         setPointsMessage('');
//       }
      
//       setPointsDiscountAmount(pointsDiscount);
      
//       // Calculate points to be earned (10% of original price)
//       const totalOriginalPrice = cartItems.reduce((total, item) => {
//         const originalPrice = item.originalPrice || item.price;
//         return total + (originalPrice * item.quantity);
//       }, 0);
      
//       const estimatedPoints = Math.floor(totalOriginalPrice * 0.1);
//       setPointsEarned(estimatedPoints);
//     }
//   }, [cartItems, usePointsDiscount, availablePoints, couponApplied]);

//   // Handle post-checkout order refresh
//   useEffect(() => {
//     if (userId && location.state && location.state.fromCheckout) {
//       console.log("Detected return from checkout, refreshing orders for user:", userId);
//       fetchOrdersFromFirestore(userId);
//       navigate(location.pathname, { state: {}, replace: true });
//     }
//   }, [location.state, userId, fetchOrdersFromFirestore, navigate, location.pathname]);

//   // Save cart to Firestore and localStorage
//   const saveCart = async (updatedItems) => {
//     console.log("Saving cart items:", updatedItems);
//     if (!Array.isArray(updatedItems)) {
//       console.error('saveCart: updatedItems is not an array:', updatedItems);
//       return;
//     }
//     localStorage.setItem('cartItems', JSON.stringify(updatedItems));
//     console.log("Saved to localStorage");
//     if (userId) {
//       try {
//         console.log("Saving to Firestore for user:", userId);
//         const cartDocRef = doc(db, 'carts', userId);
//         const itemsObject = {};
//         updatedItems.forEach(item => {
//           if (item && item.id) {
//             itemsObject[item.id] = {
//               ...item,
//               updatedAt: new Date()
//             };
//           }
//         });
//         console.log("Saving these items to Firestore:", itemsObject);
//         const cartDoc = await getDoc(cartDocRef);
//         if (cartDoc.exists()) {
//           await updateDoc(cartDocRef, {
//             items: itemsObject,
//             updatedAt: new Date()
//           });
//           console.log("Cart updated in Firestore:", Object.keys(itemsObject).length, "items");
//         } else {
//           await setDoc(cartDocRef, {
//             items: itemsObject,
//             createdAt: new Date(),
//             updatedAt: new Date()
//           });
//           console.log("New cart created in Firestore:", Object.keys(itemsObject).length, "items");
//         }
//       } catch (error) {
//         console.error('Error saving cart to Firestore:', error);
//       }
//     } else {
//       console.log("User not authenticated, not saving to Firestore");
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Toggle coupon application
//   const handleCouponToggle = () => {
//     setCouponApplied(!couponApplied);
    
//     setCartItems(prevItems => {
//       const updatedItems = prevItems.map(item => ({
//         ...item,
//         couponApplied: !couponApplied
//       }));
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Toggle points discount
//   const handlePointsToggle = () => {
//     if (!userId) {
//       // Redirect to login if not logged in
//       navigate('/login', { state: { from: '/cart' } });
//       return;
//     }
    
//     const newUsePointsDiscount = !usePointsDiscount;
//     setUsePointsDiscount(newUsePointsDiscount);
    
//     setCartItems(prevItems => {
//       if (!Array.isArray(prevItems)) {
//         console.error('handlePointsToggle: prevItems is not an array:', prevItems);
//         return [];
//       }
      
//       const baseSubtotal = calculateSubtotal();
//       const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
//       let pointsDiscount = 0;
//       let pointsToUse = 0;
      
//       if (newUsePointsDiscount && availablePoints > 0) {
//         const maxPointsDiscount = availablePoints / 100;
//         const maxAllowedDiscount = baseSubtotal - couponDiscount;
//         pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
//         pointsToUse = Math.floor(pointsDiscount * 100);
//       }
      
//       // Apply the exact same points discount to all items to maintain consistency
//       const totalItemsPrice = prevItems.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0);
      
//       const updatedItems = prevItems.map(item => {
//         // Calculate this item's proportion of the total price
//         const itemPrice = item.price * (item.quantity || 1);
//         const proportion = itemPrice / totalItemsPrice;
        
//         // Assign proportional points to this item
//         const itemPoints = newUsePointsDiscount ? Math.floor(pointsToUse * proportion) : 0;
//         const itemDiscount = itemPoints / 100;
        
//         return {
//           ...item,
//           pointsDiscount: itemDiscount,
//           pointsUsed: itemPoints
//         };
//       });
      
//       saveCart(updatedItems);
//       setPointsDiscountAmount(pointsDiscount);
      
//       return updatedItems;
//     });
//   };

//   // Update user points balance in Firestore
//   const updateUserPoints = async (newPointsBalance) => {
//     if (!userId) return;
    
//     try {
//       const userRef = doc(db, 'users', userId);
//       await updateDoc(userRef, {
//         points: newPointsBalance
//       });
      
//       setAvailablePoints(newPointsBalance);
      
//       if (userData) {
//         const updatedUserData = {
//           ...userData,
//           points: newPointsBalance
//         };
//         setUserData(updatedUserData);
//         localStorage.setItem('userData', JSON.stringify(updatedUserData));
//       }
      
//       console.log(`Updated user points balance to ${newPointsBalance}`);
      
//       // Dispatch an event to refresh profile page if it's open
//       const refreshEvent = new Event('refreshProfile');
//       window.dispatchEvent(refreshEvent);
//     } catch (error) {
//       console.error("Error updating user points:", error);
//     }
//   };

//   // Change delivery speed for a single item
//   const changeDeliverySpeed = (itemId, newSpeed) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('changeDeliverySpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) => {
//         if (item.id === itemId) {
//           const surcharge = calculateDeliverySurcharge(item.originalDeliverySpeed, newSpeed);
//           return {
//             ...item,
//             deliverySpeed: newSpeed,
//             deliverySurcharge: surcharge
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Change delivery speed for all items in a category (bulk change)
//   const changeAllDeliverySpeed = (currentSpeed, newSpeed) => {
//     console.log(`Changing all items from ${currentSpeed} to ${newSpeed}`);
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('changeAllDeliverySpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map(item => {
//         if (item.deliverySpeed === currentSpeed) {
//           const surcharge = calculateDeliverySurcharge(item.originalDeliverySpeed, newSpeed);
//           return {
//             ...item,
//             deliverySpeed: newSpeed,
//             deliverySurcharge: surcharge
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Return all items in a delivery speed category to their original speeds
//   const returnAllToOriginalSpeed = (speedCategory) => {
//     console.log(`Returning all items in ${speedCategory} to their original delivery speeds`);
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('returnAllToOriginalSpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map(item => {
//         if (item.deliverySpeed === speedCategory) {
//           return {
//             ...item,
//             deliverySpeed: item.originalDeliverySpeed || 'normal',
//             deliverySurcharge: 0
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Return to original delivery speed
//   const returnToOriginalSpeed = (itemId, originalSpeed) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('returnToOriginalSpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) => {
//         if (item.id === itemId) {
//           return {
//             ...item,
//             deliverySpeed: originalSpeed,
//             deliverySurcharge: 0
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Increment quantity
//   const incrementQuantity = (itemId) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('incrementQuantity: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) =>
//         item.id === itemId ? { ...item, quantity: (item.quantity || 1) + 1 } : item
//       );
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Decrement quantity
//   const decrementQuantity = (itemId) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('decrementQuantity: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems
//         .map((item) =>
//           item.id === itemId
//             ? { ...item, quantity: Math.max((item.quantity || 1) - 1, 1) }
//             : item
//         )
//         .filter((item) => item.quantity > 0);
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Remove item
//   const removeItem = async (itemId) => {
//     const currentItems = Array.isArray(cartItems) ? [...cartItems] : [];
//     const updatedItems = currentItems.filter((item) => item.id !== itemId);
//     localStorage.setItem('cartItems', JSON.stringify(updatedItems));
//     setCartItems(updatedItems);
//     if (userId) {
//       try {
//         const cartDocRef = doc(db, 'carts', userId);
//         const itemsObject = {};
//         updatedItems.forEach(item => {
//           if (item && item.id) {
//             itemsObject[item.id] = {
//               ...item,
//               updatedAt: new Date()
//             };
//           }
//         });
//         await updateDoc(cartDocRef, {
//           items: itemsObject,
//           updatedAt: new Date()
//         });
//         console.log("Cart updated in Firestore after removal:", itemsObject);
//         await updateDoc(cartDocRef, {
//           [`items.${itemId}`]: deleteField()
//         });
//       } catch (error) {
//         console.error('Error removing item from Firestore:', error);
//       }
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Calculate subtotal (without delivery surcharges)
//   const calculateSubtotal = () => {
//     if (!Array.isArray(cartItems)) {
//       console.error('calculateSubtotal: cartItems is not an array:', cartItems);
//       return 0;
//     }
//     return cartItems.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
//   };

//   // Calculate total delivery surcharges
//   const calculateTotalSurcharges = () => {
//     if (!Array.isArray(cartItems)) {
//       console.error('calculateTotalSurcharges: cartItems is not an array:', cartItems);
//       return 0;
//     }
//     return cartItems.reduce((total, item) => {
//       const surcharge = item.deliverySurcharge || 0;
//       return total + (surcharge * (item.quantity || 1));
//     }, 0);
//   };

//   // Calculate coupon discount
//   const calculateCouponDiscount = () => {
//     if (!couponApplied) return 0;
//     return calculateSubtotal() * 0.02; // 2% discount
//   };

//   // Calculate total including surcharges and discounts
//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     const surcharges = calculateTotalSurcharges();
//     const couponDiscount = calculateCouponDiscount();
//     return subtotal + surcharges - couponDiscount - pointsDiscountAmount;
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//   };

//   // Clear cart after successful order
//   const clearCart = async () => {
//     localStorage.removeItem('cartItems');
//     setCartItems([]);
//     if (userId) {
//       try {
//         const cartDocRef = doc(db, 'carts', userId);
//         await setDoc(cartDocRef, {
//           items: {},
//           updatedAt: new Date()
//         });
//         console.log("Cart cleared in Firestore");
//       } catch (error) {
//         console.error('Error clearing cart from Firestore:', error);
//       }
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Handle proceed to checkout
//   const handleProceedToCheckout = () => {
//     const token = localStorage.getItem('authToken');
//     if (token) {
//       navigate('/checkout');
//     } else {
//       navigate('/login', { state: { from: '/checkout' } });
//     }
//   };

//   // Handle start shopping
//   const handleStartShopping = () => {
//     navigate('/products');
//   };

//   // Fix image URL
//   const getImageUrl = (image) => {
//     if (!image) return 'https://via.placeholder.com/100x100?text=Product';
//     if (typeof image === 'string' && image.startsWith('https://firebasestorage.googleapis.com')) {
//       return image;
//     }
//     if (image.startsWith('http')) return image;
//     if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) {
//       return image.imageUrl;
//     }
//     return `/images/${image}`;
//   };

//   // Get delivery icon
//   const getDeliveryIcon = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return '⚡';
//       case 'express':
//         return '🚀';
//       case 'late':
//         return '🐌';
//       case 'normal':
//       default:
//         return '🚚';
//     }
//   };

//   // Get delivery title
//   const getDeliveryTitle = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return 'Quick Delivery';
//       case 'express':
//         return 'Express Delivery';
//       case 'late':
//         return 'Eco Delivery';
//       case 'normal':
//       default:
//         return 'Standard Delivery';
//     }
//   };

//   // Group cart items
//   const groupedCartItems = () => {
//     const grouped = {
//       quick: [],
//       normal: [],
//       late: []
//     };
//     if (!Array.isArray(cartItems)) {
//       console.error('groupedCartItems: cartItems is not an array:', cartItems);
//       return grouped;
//     }
//     cartItems.forEach(item => {
//       const speed = item.deliverySpeed || 'normal';
//       if (grouped[speed]) {
//         grouped[speed].push(item);
//       } else {
//         grouped.normal.push(item);
//       }
//     });
//     return grouped;
//   };

//   // Check if there are items with non-original delivery speeds in a category
//   const hasNonOriginalItems = (items) => {
//     return items.some(item => item.deliverySpeed !== item.originalDeliverySpeed);
//   };

//   if (loading) {
//     return (
//       <div className="cart-loading">
//         <p>Loading your cart...</p>
//       </div>
//     );
//   }

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const grouped = groupedCartItems();
//   const subtotal = calculateSubtotal();
//   const totalSurcharges = calculateTotalSurcharges();
//   const couponDiscount = calculateCouponDiscount();
//   console.log("Grouped items:", grouped);
//   console.log("Subtotal:", subtotal);
//   console.log("Total surcharges:", totalSurcharges);
//   console.log("Points discount:", pointsDiscountAmount);

//   return (
//     <div className="cart-container">
//       <button className="go-back-btn2" onClick={handleGoBack}>
//         ← Go Back
//       </button>
//       {cartItems.length === 0 ? (
//         <div className="cart-empty">
//           <div className="cart-empty-bg"></div>
//           <svg
//             className="cart-icon"
//             width="80"
//             height="80"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//           >
//             <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
//           </svg>
//           <h2 className="cart-title">Your Cart is Empty</h2>
//           <p className="cart-subtitle">
//             Looks like you haven't added anything to your cart yet. Let's get started!
//           </p>
//           <button className="cart-button1" onClick={handleStartShopping}>
//             Start Shopping Now
//           </button>
//         </div>
//       ) : (
//         <div className="cart-content">
//           <h2 className="cart-title">Your Cart ({cartItems.length} {cartItems.length === 1 ? 'Item' : 'Items'})</h2>
//           {/* Quick Delivery Section */}
//           {grouped.quick.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section quick-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('quick')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Quick Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivered today</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('quick', 'normal')}
//                     aria-label="Change all to standard delivery"
//                     title="Move all to Standard Delivery"
//                   >
//                     <span className="btn-icon">↓</span>
//                     <span className="btn-label">Move to Standard</span>
//                   </button>
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('quick', 'late')}
//                     aria-label="Change all to eco delivery"
//                     title="Move all to Eco Delivery"
//                   >
//                     <span className="btn-icon">↓↓</span>
//                     <span className="btn-label">Move to Eco</span>
//                   </button>
//                   {hasNonOriginalItems(grouped.quick) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('quick')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.quick.length} {grouped.quick.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.quick.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'quick' && (
//                           <>
//                             {item.deliverySpeed !== 'normal' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                 aria-label="Change to standard delivery"
//                                 title="Move to Standard Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Standard</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           {/* Standard Delivery Section */}
//           {grouped.normal.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section normal-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('normal')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Standard Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivery by next day</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   {grouped.normal.some(item => item.originalDeliverySpeed === 'normal') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('normal', 'quick')}
//                       aria-label="Change all to quick delivery"
//                       title="Move all to Quick Delivery (+₹80 each for standard origin items)"
//                     >
//                       <span className="btn-icon">↑</span>
//                       <span className="btn-label">Move to Quick +₹80</span>
//                     </button>
//                   )}
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('normal', 'late')}
//                     aria-label="Change all to eco delivery"
//                     title="Move all to Eco Delivery"
//                   >
//                     <span className="btn-icon">↓</span>
//                     <span className="btn-label">Move to Eco</span>
//                   </button>
//                   {hasNonOriginalItems(grouped.normal) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('normal')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.normal.length} {grouped.normal.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.normal.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'normal' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed === 'quick' && (
//                           <>
//                             {item.deliverySpeed !== 'normal' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                 aria-label="Change to standard delivery"
//                                 title="Move to Standard Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Standard</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed === 'late' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                               aria-label="Change to standard delivery"
//                               title="Move to Standard Delivery (+₹60)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Standard +₹60</span>
//                             </button>
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           {/* Eco Delivery Section */}
//           {grouped.late.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section late-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('late')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Eco Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivery by 2 days</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   {grouped.late.some(item => item.originalDeliverySpeed === 'late') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('late', 'quick')}
//                       aria-label="Change all to quick delivery"
//                       title="Move all to Quick Delivery (+₹80 each for eco origin items)"
//                     >
//                       <span className="btn-icon">↑↑</span>
//                       <span className="btn-label">Move to Quick +₹80</span>
//                     </button>
//                   )}
//                   {grouped.late.some(item => item.originalDeliverySpeed === 'late') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('late', 'normal')}
//                       aria-label="Change all to standard delivery"
//                       title="Move all to Standard Delivery (+₹60 each for eco origin items)"
//                     >
//                       <span className="btn-icon">↑</span>
//                       <span className="btn-label">Move to Standard +₹60</span>
//                     </button>
//                   )}
//                   {hasNonOriginalItems(grouped.late) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('late')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.late.length} {grouped.late.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.late.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'late' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                               aria-label="Change to standard delivery"
//                               title="Move to Standard Delivery (+₹60)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Standard +₹60</span>
//                             </button>
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed !== 'late' && (
//                           <>
//                             {item.originalDeliverySpeed === 'quick' && (
//                               <>
//                                 {item.deliverySpeed !== 'normal' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                     aria-label="Change to standard delivery"
//                                     title="Move to Standard Delivery"
//                                   >
//                                     <span className="btn-icon">↓</span>
//                                     <span className="btn-label">Standard</span>
//                                   </button>
//                                 )}
//                                 {item.deliverySpeed !== 'late' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                     aria-label="Change to eco delivery"
//                                     title="Move to Eco Delivery"
//                                   >
//                                     <span className="btn-icon">↓↓</span>
//                                     <span className="btn-label">Eco</span>
//                                   </button>
//                                 )}
//                               </>
//                             )}
//                             {item.originalDeliverySpeed === 'normal' && (
//                               <>
//                                 <button
//                                   className="delivery-btn up with-label"
//                                   onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                                   aria-label="Change to quick delivery"
//                                   title="Move to Quick Delivery (+₹80)"
//                                 >
//                                   <span className="btn-icon">↑</span>
//                                   <span className="btn-label">Quick +₹80</span>
//                                 </button>
//                                 {item.deliverySpeed !== 'late' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                     aria-label="Change to eco delivery"
//                                     title="Move to Eco Delivery"
//                                   >
//                                     <span className="btn-icon">↓</span>
//                                     <span className="btn-label">Eco</span>
//                                   </button>
//                                 )}
//                               </>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           <div className="cart-summary">
//             {/* Discounts section */}
//             <div className="cart-discounts">
//               <h3>Discounts & Rewards</h3>
              
              
//               {/* Points discount */}
//               {userId ? (
//                 <div className="discount-option">
//                   <label className="discount-checkbox">
//                     <input
//                       type="checkbox"
//                       checked={usePointsDiscount}
//                       onChange={handlePointsToggle}
//                       disabled={availablePoints < 100}
//                     />
//                     <span>
//                       Use loyalty points ({availablePoints} available)
//                     </span>
//                   </label>
//                   {usePointsDiscount && pointsMessage && (
//                     <div className="points-info">
//                       {pointsMessage}
//                     </div>
//                   )}
//                   {availablePoints < 100 && (
//                     <div className="insufficient-points">
//                       Minimum 100 points required to redeem
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <div className="discount-option">
//                   <button 
//                     className="login-for-points-btn"
//                     onClick={() => navigate('/login', { state: { from: '/cart' } })}
//                   >
//                     Log in to use your loyalty points
//                   </button>
//                 </div>
//               )}
              
              
//             </div>
            
//             <div className="cart-summary-details">
//               <div className="summary-row">
//                 <span>Subtotal:</span>
//                 <span>{formatCurrency(subtotal)}</span>
//               </div>
//               {couponDiscount > 0 && (
//                 <div className="summary-row discount">
//                   <span>Coupon Discount (2%):</span>
//                   <span>-{formatCurrency(couponDiscount)}</span>
//                 </div>
//               )}
//               {pointsDiscountAmount > 0 && (
//                 <div className="summary-row points-discount">
//                   <span>Points Discount:</span>
//                   <span>-{formatCurrency(pointsDiscountAmount)}</span>
//                 </div>
//               )}
//               {totalSurcharges > 0 && (
//                 <div className="summary-row surcharge">
//                   <span>Delivery Surcharges:</span>
//                   <span>+{formatCurrency(totalSurcharges)}</span>
//                 </div>
//               )}
//               <div className="summary-row total">
//                 <span>Total:</span>
//                 <span>{formatCurrency(calculateTotal())}</span>
//               </div>
//             </div>
            
//             <button 
//               className="checkout-btn" 
//               onClick={handleProceedToCheckout}
//             >
//               Proceed to Checkout
//             </button>
            
//             {orderError && (
//               <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
//                 {orderError}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Cart;










// import React, { useState, useEffect, useCallback } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';
// import { doc, getDoc, setDoc, updateDoc, deleteField, collection, getDocs, query, where } from 'firebase/firestore';
// import { db, auth } from '../../firebase/firebaseConfig';
// import { onAuthStateChanged } from 'firebase/auth';
// import './Cart.css';

// const Cart = () => {
//   const [cartItems, setCartItems] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [userId, setUserId] = useState(null);
//   const [orders, setOrders] = useState([]);
//   const [loadingOrders, setLoadingOrders] = useState(true);
//   const [isOrderHistoryExpanded, setIsOrderHistoryExpanded] = useState(false);
  
//   // Error state
//   const [orderError, setOrderError] = useState(null);
//   const [userData, setUserData] = useState(null);
  
//   // Points and coupon states
//   const [usePointsDiscount, setUsePointsDiscount] = useState(false);
//   const [pointsDiscountAmount, setPointsDiscountAmount] = useState(0);
//   const [availablePoints, setAvailablePoints] = useState(0);
//   const [pointsMessage, setPointsMessage] = useState('');
//   const [pointsEarned, setPointsEarned] = useState(0);
//   const [couponApplied, setCouponApplied] = useState(false);
//   const [discountAmount, setDiscountAmount] = useState(0);
  
//   // Time restriction states
//   const [isOrderingAllowed, setIsOrderingAllowed] = useState(true);
//   const [showTimeAlert, setShowTimeAlert] = useState(false);
  
//   const navigate = useNavigate();
//   const location = useLocation();

//   // Check if ordering is allowed based on current time
//   useEffect(() => {
//     const checkOrderingTime = () => {
//       const now = new Date();
//       const hours = now.getHours();
//       // If current time is after 3 PM (15:00), ordering is not allowed
//       if (hours >= 15) {
//         setIsOrderingAllowed(false);
//       } else {
//         setIsOrderingAllowed(true);
//       }
//     };
    
//     // Check immediately when component mounts
//     checkOrderingTime();
    
//     // Set up interval to check every minute
//     const timeCheckInterval = setInterval(checkOrderingTime, 60000);
    
//     // Clean up interval
//     return () => clearInterval(timeCheckInterval);
//   }, []);

//   // Normalize delivery speed values
//   const normalizeDeliverySpeed = (speed) => {
//     if (!speed) return 'normal';
//     const speedLower = typeof speed === 'string' ? speed.toLowerCase() : 'normal';
//     if (speedLower.includes('express') || speedLower.includes('quick')) {
//       return 'quick';
//     } else if (speedLower.includes('late')) {
//       return 'late';
//     } else {
//       return 'normal';
//     }
//   };

//   // Calculate delivery surcharge based on original and current delivery speed
//   const calculateDeliverySurcharge = (originalSpeed, currentSpeed) => {
//     if (originalSpeed === currentSpeed) {
//       return 0;
//     }
//     if (originalSpeed === 'quick') {
//       return 0;
//     } else if (originalSpeed === 'normal' || originalSpeed === 'standard') {
//       if (currentSpeed === 'quick') {
//         return 80;
//       }
//       return 0;
//     } else if (originalSpeed === 'late') {
//       if (currentSpeed === 'quick') {
//         return 80;
//       } else if (currentSpeed === 'normal' || currentSpeed === 'standard') {
//         return 60;
//       }
//     }
//     return 0;
//   };

//   // Fetch cart from Firestore (memoized)
//   const fetchCartFromFirestore = useCallback(async (uid) => {
//     try {
//       console.log("Fetching cart from Firestore for user:", uid);
//       const cartDocRef = doc(db, 'carts', uid);
//       const cartDoc = await getDoc(cartDocRef);
//       if (cartDoc.exists()) {
//         const cartData = cartDoc.data();
//         console.log("Firestore cart data:", cartData);
//         if (cartData.items && Object.keys(cartData.items).length > 0) {
//           const cartItemsArray = Object.values(cartData.items || {});
//           console.log("Firestore cart items array:", cartItemsArray);
//           const validItems = cartItemsArray
//             .filter(item => {
//               console.log("Cart item before validation:", item);
//               const isValid = item && item.id && item.name && item.price;
//               if (!isValid) {
//                 console.log("Invalid item found:", item);
//                 console.log("Missing properties:", {
//                   hasItem: !!item,
//                   hasId: item && !!item.id,
//                   hasName: item && !!item.name,
//                   hasPrice: item && !!item.price
//                 });
//               }
//               return isValid;
//             })
//             .map(item => {
//               const normalizedDeliverySpeed = normalizeDeliverySpeed(item.deliverySpeed);
//               const normalizedOriginalSpeed = item.originalDeliverySpeed ?
//                 normalizeDeliverySpeed(item.originalDeliverySpeed) :
//                 normalizedDeliverySpeed;
//               return {
//                 ...item,
//                 quantity: item.quantity || 1,
//                 deliverySpeed: normalizedDeliverySpeed,
//                 originalDeliverySpeed: normalizedOriginalSpeed,
//                 deliverySurcharge: calculateDeliverySurcharge(normalizedOriginalSpeed, normalizedDeliverySpeed),
//                 couponApplied: item.couponApplied || false,
//                 pointsDiscount: item.pointsDiscount || 0,
//                 pointsUsed: item.pointsUsed || 0
//               };
//             });
//           console.log("Loaded items from Firestore:", validItems);
//           if (validItems.length > 0) {
//             setCartItems(validItems);
//             localStorage.setItem('cartItems', JSON.stringify(validItems));
//             console.log("Updated cart with Firestore items:", validItems.length);
            
//             // Check if points discount was applied
//             const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
//             if (anyPointsUsed) {
//               setUsePointsDiscount(true);
//             }
            
//             // Check if coupon was applied
//             const anyCouponApplied = validItems.some(item => item.couponApplied);
//             setCouponApplied(anyCouponApplied);
//           } else {
//             console.log("No valid items found in Firestore, checking localStorage");
//             fetchCartFromLocalStorage();
//           }
//         } else {
//           console.log("No items in Firestore cart, checking localStorage");
//           fetchCartFromLocalStorage();
//         }
//       } else {
//         console.log("Cart document does not exist in Firestore, checking localStorage");
//         fetchCartFromLocalStorage();
//       }
//     } catch (error) {
//       console.error('Error fetching cart from Firestore:', error);
//       fetchCartFromLocalStorage();
//     }
//   }, []);

//   // Fetch cart from localStorage (memoized)
//   const fetchCartFromLocalStorage = useCallback(() => {
//     console.log("Fetching cart from localStorage");
//     const storedCart = localStorage.getItem('cartItems');
//     console.log("Raw localStorage cartItems:", storedCart);
    
//     if (storedCart) {
//       try {
//         const parsedCart = JSON.parse(storedCart);
//         console.log("Parsed localStorage cartItems:", parsedCart);
//         let itemsToProcess = parsedCart;
//         if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
//           console.log("Found items property in localStorage cart object");
//           itemsToProcess = parsedCart.items;
//         }
//         if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
//           console.log("Converting object to array from localStorage");
//           itemsToProcess = Object.values(itemsToProcess);
//         }
//         if (!Array.isArray(itemsToProcess)) {
//           console.log("itemsToProcess is not an array, setting to empty array");
//           itemsToProcess = [];
//         }
//         const validItems = itemsToProcess
//           .filter(item => {
//             console.log("Cart item before validation:", item);
//             const isValid = item && item.id && item.name;
//             if (!isValid) {
//               console.log("Invalid item found:", item);
//               console.log("Missing properties:", {
//                 hasItem: !!item,
//                 hasId: item && !!item.id,
//                 hasName: item && !!item.name
//               });
//             }
//             return isValid;
//           })
//           .map(item => {
//             const normalizedDeliverySpeed = normalizeDeliverySpeed(item.deliverySpeed);
//             const normalizedOriginalSpeed = item.originalDeliverySpeed ?
//               normalizeDeliverySpeed(item.originalDeliverySpeed) :
//               normalizedDeliverySpeed;
//             return {
//               ...item,
//               price: item.price || 0,
//               originalPrice: item.originalPrice || item.price || 0, // Ensure originalPrice exists
//               quantity: item.quantity || 1,
//               deliverySpeed: normalizedDeliverySpeed,
//               originalDeliverySpeed: normalizedOriginalSpeed,
//               deliverySurcharge: calculateDeliverySurcharge(normalizedOriginalSpeed, normalizedDeliverySpeed),
//               couponApplied: item.couponApplied || false,
//               pointsDiscount: item.pointsDiscount || 0,
//               pointsUsed: item.pointsUsed || 0
//             };
//           });
//         console.log("Loaded items from localStorage:", validItems);
//         console.log("Valid items count:", validItems.length);
//         if (validItems.length > 0) {
//           setCartItems(validItems);
//           localStorage.setItem('cartItems', JSON.stringify(validItems));
//           console.log("Updated localStorage with normalized items");
          
//           // Check if points discount was applied
//           const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
//           if (anyPointsUsed) {
//             setUsePointsDiscount(true);
//           }
          
//           // Check if coupon was applied
//           const anyCouponApplied = validItems.some(item => item.couponApplied);
//           setCouponApplied(anyCouponApplied);
//         } else {
//           console.log("No valid items found in localStorage");
//           setCartItems([]);
//         }
//       } catch (error) {
//         console.error('Error parsing cart items from localStorage:', error);
//         setCartItems([]);
//       }
//     } else {
//       console.log("No cart items in localStorage, setting to empty.");
//       setCartItems([]);
//     }
//   }, []);

//   // Fetch orders from Firestore (memoized)
//   const fetchOrdersFromFirestore = useCallback(async (uid) => {
//     setLoadingOrders(true);
//     try {
//       console.log("Fetching orders from Firestore for user:", uid);
//       const ordersCollectionRef = collection(db, 'orders');
//       const q = query(ordersCollectionRef, where('userId', '==', uid));
//       const ordersSnapshot = await getDocs(q);
//       console.log("Firestore orders snapshot empty?", ordersSnapshot.empty);
//       console.log("Number of orders fetched:", ordersSnapshot.docs.length);
//       if (ordersSnapshot.empty) {
//         console.log("No orders found for user in Firestore at path 'orders' with userId:", uid);
//         setOrders([]);
//         return;
//       }
//       const ordersList = ordersSnapshot.docs.map(doc => {
//         const data = doc.data();
//         console.log(`Order document ${doc.id} data:`, data);
//         const items = data.cartItems || data.items || data.orderItems || [];
//         const total = data.total !== undefined ? data.total : 0;
//         const status = data.status || 'pending';
//         const isValidItems = Array.isArray(items) && items.every(item => item.id && item.name);
//         if (!isValidItems) {
//           console.warn(`Order ${doc.id} has invalid or missing items:`, items);
//           return null;
//         }
//         const normalizedItems = items.map(item => ({
//           id: item.id,
//           name: item.name,
//           price: item.price || 0,
//           quantity: item.quantity || 1,
//           deliverySpeed: normalizeDeliverySpeed(item.deliverySpeed),
//           image: item.image || item.imageUrl,
//           imageUrl: item.imageUrl || item.image,
//         }));
//         const date = data.orderDate || data.date;
//         const parsedDate = date && typeof date.toDate === 'function' ? date : new Date();
//         if (!date || (typeof date.toDate !== 'function' && isNaN(new Date(date).getTime()))) {
//           console.warn(`Order ${doc.id} has invalid date field, using current date as fallback:`, date);
//         }
//         return {
//           id: doc.id,
//           items: normalizedItems,
//           total,
//           status,
//           date: parsedDate,
//         };
//       }).filter(order => order !== null);
//       console.log("Processed orders list:", ordersList);
//       if (ordersList.length === 0) {
//         console.log("No valid orders after processing. Check field names and data structure.");
//         setOrders([]);
//         return;
//       }
//       const sortedOrders = ordersList.sort((a, b) => {
//         const dateA = a.date.toDate ? a.date.toDate() : new Date(a.date);
//         const dateB = b.date.toDate ? b.date.toDate() : new Date(b.date);
//         return dateB - dateA;
//       });
//       console.log("Sorted orders:", sortedOrders);
//       setOrders(sortedOrders);
//       console.log("Orders state updated with:", sortedOrders);
//     } catch (error) {
//       console.error('Error fetching orders from Firestore:', error);
//       setOrders([]);
//     } finally {
//       setLoadingOrders(false);
//     }
//   }, []);

//   // Check authentication, load data, and handle post-checkout refresh
//   useEffect(() => {
//     console.log("Cart component mounted, checking auth state");
//     const quickCheck = localStorage.getItem('cartItems');
//     if (quickCheck) {
//       try {
//         const parsedItems = JSON.parse(quickCheck);
//         if (Array.isArray(parsedItems) && parsedItems.length > 0) {
//           console.log("Found cart items in localStorage, displaying temporarily:", parsedItems.length);
//           setCartItems(parsedItems);
//         }
//       } catch (e) {
//         console.error("Error parsing localStorage cart for quick display:", e);
//       }
//     }
//     let authInitialized = false;
//     const unsubscribe = onAuthStateChanged(auth, async (user) => {
//       console.log("Auth state changed:", user ? user.uid : "No user");
//       if (!authInitialized) {
//         authInitialized = true;
//         setLoading(false);
//       }
//       if (user) {
//         console.log("User is authenticated:", user.uid);
//         setUserId(user.uid);
//         fetchCartFromFirestore(user.uid);
//         fetchOrdersFromFirestore(user.uid);
        
//         // Load user data for points system
//         try {
//           const userDocRef = query(
//             collection(db, 'users'),
//             where('email', '==', user.email)
//           );
//           const userSnapshot = await getDocs(userDocRef);
//           if (!userSnapshot.empty) {
//             const userData = userSnapshot.docs[0].data();
//             const userPoints = userData.points || 0;
//             setAvailablePoints(userPoints);
//             setUserData({
//               uid: user.uid,
//               email: user.email,
//               name: userData.name || user.displayName || 'User',
//               phone: userData.phone || '',
//               deliveryAddress: userData.deliveryAddress || '',
//               points: userPoints
//             });
//           } else {
//             // Fallback to stored user data in localStorage
//             const storedUserData = localStorage.getItem('userData');
//             if (storedUserData) {
//               const parsedUserData = JSON.parse(storedUserData);
//               setUserData(parsedUserData);
//               setAvailablePoints(parsedUserData.points || 0);
//             }
//           }
//         } catch (error) {
//           console.error("Error loading user data:", error);
//         }
//       } else {
//         console.log("User is not authenticated, using localStorage");
//         setUserId(null);
//         fetchCartFromLocalStorage();
//         if (authInitialized) {
//           setOrders([]);
//           setLoadingOrders(false);
//         }
        
//         // Try to load user data from localStorage
//         const storedUserData = localStorage.getItem('userData');
//         if (storedUserData) {
//           try {
//             const parsedUserData = JSON.parse(storedUserData);
//             setUserData(parsedUserData);
//             setAvailablePoints(parsedUserData.points || 0);
//           } catch (error) {
//             console.error("Error parsing stored user data:", error);
//           }
//         }
//       }
//     });

//     // Listen for cart update events
//     const handleCartUpdate = () => {
//       console.log("Cart update event detected");
//       if (userId) {
//         fetchCartFromFirestore(userId);
//       } else {
//         fetchCartFromLocalStorage();
//       }
//     };

//     window.addEventListener('cartUpdated', handleCartUpdate);

//     return () => {
//       unsubscribe();
//       window.removeEventListener('cartUpdated', handleCartUpdate);
//     };
//   }, [fetchCartFromFirestore, fetchCartFromLocalStorage, fetchOrdersFromFirestore]);

//   // Calculate points discount and update messages
//   useEffect(() => {
//     if (cartItems && cartItems.length > 0) {
//       const baseSubtotal = calculateSubtotal();
//       const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
//       setDiscountAmount(couponDiscount);
      
//       // First check if any existing points are already applied in cart items
//       const existingPointsUsed = cartItems.reduce((total, item) => {
//         return total + (item.pointsUsed || 0);
//       }, 0);
      
//       let pointsDiscount = 0;
      
//       if (existingPointsUsed > 0) {
//         // If points are already applied, use that exact value
//         pointsDiscount = existingPointsUsed / 100;
//         setPointsMessage(`Using ${existingPointsUsed} points for ₹${pointsDiscount.toFixed(2)} discount`);
//         setUsePointsDiscount(true);
//       } else if (usePointsDiscount && availablePoints > 0) {
//         // Otherwise calculate new discount if enabled
//         // 100 points = ₹1 discount
//         const maxPointsDiscount = availablePoints / 100;
//         const maxAllowedDiscount = baseSubtotal - couponDiscount;
//         pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        
//         if (pointsDiscount > 0) {
//           setPointsMessage(`Using ${Math.floor(pointsDiscount * 100)} points for ₹${pointsDiscount.toFixed(2)} discount`);
//         } else {
//           setPointsMessage('Not enough points for discount');
//         }
//       } else {
//         setPointsMessage('');
//       }
      
//       setPointsDiscountAmount(pointsDiscount);
      
//       // Calculate points to be earned (10% of original price)
//       const totalOriginalPrice = cartItems.reduce((total, item) => {
//         const originalPrice = item.originalPrice || item.price;
//         return total + (originalPrice * item.quantity);
//       }, 0);
      
//       const estimatedPoints = Math.floor(totalOriginalPrice * 0.1);
//       setPointsEarned(estimatedPoints);
//     }
//   }, [cartItems, usePointsDiscount, availablePoints, couponApplied]);

//   // Handle post-checkout order refresh
//   useEffect(() => {
//     if (userId && location.state && location.state.fromCheckout) {
//       console.log("Detected return from checkout, refreshing orders for user:", userId);
//       fetchOrdersFromFirestore(userId);
//       navigate(location.pathname, { state: {}, replace: true });
//     }
//   }, [location.state, userId, fetchOrdersFromFirestore, navigate, location.pathname]);

//   // Save cart to Firestore and localStorage
//   const saveCart = async (updatedItems) => {
//     console.log("Saving cart items:", updatedItems);
//     if (!Array.isArray(updatedItems)) {
//       console.error('saveCart: updatedItems is not an array:', updatedItems);
//       return;
//     }
//     localStorage.setItem('cartItems', JSON.stringify(updatedItems));
//     console.log("Saved to localStorage");
//     if (userId) {
//       try {
//         console.log("Saving to Firestore for user:", userId);
//         const cartDocRef = doc(db, 'carts', userId);
//         const itemsObject = {};
//         updatedItems.forEach(item => {
//           if (item && item.id) {
//             itemsObject[item.id] = {
//               ...item,
//               updatedAt: new Date()
//             };
//           }
//         });
//         console.log("Saving these items to Firestore:", itemsObject);
//         const cartDoc = await getDoc(cartDocRef);
//         if (cartDoc.exists()) {
//           await updateDoc(cartDocRef, {
//             items: itemsObject,
//             updatedAt: new Date()
//           });
//           console.log("Cart updated in Firestore:", Object.keys(itemsObject).length, "items");
//         } else {
//           await setDoc(cartDocRef, {
//             items: itemsObject,
//             createdAt: new Date(),
//             updatedAt: new Date()
//           });
//           console.log("New cart created in Firestore:", Object.keys(itemsObject).length, "items");
//         }
//       } catch (error) {
//         console.error('Error saving cart to Firestore:', error);
//       }
//     } else {
//       console.log("User not authenticated, not saving to Firestore");
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Toggle coupon application
//   const handleCouponToggle = () => {
//     setCouponApplied(!couponApplied);
    
//     setCartItems(prevItems => {
//       const updatedItems = prevItems.map(item => ({
//         ...item,
//         couponApplied: !couponApplied
//       }));
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Toggle points discount
//   const handlePointsToggle = () => {
//     if (!userId) {
//       // Redirect to login if not logged in
//       navigate('/login', { state: { from: '/cart' } });
//       return;
//     }
    
//     const newUsePointsDiscount = !usePointsDiscount;
//     setUsePointsDiscount(newUsePointsDiscount);
    
//     setCartItems(prevItems => {
//       if (!Array.isArray(prevItems)) {
//         console.error('handlePointsToggle: prevItems is not an array:', prevItems);
//         return [];
//       }
      
//       const baseSubtotal = calculateSubtotal();
//       const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
//       let pointsDiscount = 0;
//       let pointsToUse = 0;
      
//       if (newUsePointsDiscount && availablePoints > 0) {
//         const maxPointsDiscount = availablePoints / 100;
//         const maxAllowedDiscount = baseSubtotal - couponDiscount;
//         pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
//         pointsToUse = Math.floor(pointsDiscount * 100);
//       }
      
//       // Apply the exact same points discount to all items to maintain consistency
//       const totalItemsPrice = prevItems.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0);
      
//       const updatedItems = prevItems.map(item => {
//         // Calculate this item's proportion of the total price
//         const itemPrice = item.price * (item.quantity || 1);
//         const proportion = itemPrice / totalItemsPrice;
        
//         // Assign proportional points to this item
//         const itemPoints = newUsePointsDiscount ? Math.floor(pointsToUse * proportion) : 0;
//         const itemDiscount = itemPoints / 100;
        
//         return {
//           ...item,
//           pointsDiscount: itemDiscount,
//           pointsUsed: itemPoints
//         };
//       });
      
//       saveCart(updatedItems);
//       setPointsDiscountAmount(pointsDiscount);
      
//       return updatedItems;
//     });
//   };

//   // Update user points balance in Firestore
//   const updateUserPoints = async (newPointsBalance) => {
//     if (!userId) return;
    
//     try {
//       const userRef = doc(db, 'users', userId);
//       await updateDoc(userRef, {
//         points: newPointsBalance
//       });
      
//       setAvailablePoints(newPointsBalance);
      
//       if (userData) {
//         const updatedUserData = {
//           ...userData,
//           points: newPointsBalance
//         };
//         setUserData(updatedUserData);
//         localStorage.setItem('userData', JSON.stringify(updatedUserData));
//       }
      
//       console.log(`Updated user points balance to ${newPointsBalance}`);
      
//       // Dispatch an event to refresh profile page if it's open
//       const refreshEvent = new Event('refreshProfile');
//       window.dispatchEvent(refreshEvent);
//     } catch (error) {
//       console.error("Error updating user points:", error);
//     }
//   };

//   // Change delivery speed for a single item
//   const changeDeliverySpeed = (itemId, newSpeed) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('changeDeliverySpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) => {
//         if (item.id === itemId) {
//           const surcharge = calculateDeliverySurcharge(item.originalDeliverySpeed, newSpeed);
//           return {
//             ...item,
//             deliverySpeed: newSpeed,
//             deliverySurcharge: surcharge
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Change delivery speed for all items in a category (bulk change)
//   const changeAllDeliverySpeed = (currentSpeed, newSpeed) => {
//     console.log(`Changing all items from ${currentSpeed} to ${newSpeed}`);
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('changeAllDeliverySpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map(item => {
//         if (item.deliverySpeed === currentSpeed) {
//           const surcharge = calculateDeliverySurcharge(item.originalDeliverySpeed, newSpeed);
//           return {
//             ...item,
//             deliverySpeed: newSpeed,
//             deliverySurcharge: surcharge
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Return all items in a delivery speed category to their original speeds
//   const returnAllToOriginalSpeed = (speedCategory) => {
//     console.log(`Returning all items in ${speedCategory} to their original delivery speeds`);
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('returnAllToOriginalSpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map(item => {
//         if (item.deliverySpeed === speedCategory) {
//           return {
//             ...item,
//             deliverySpeed: item.originalDeliverySpeed || 'normal',
//             deliverySurcharge: 0
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Return to original delivery speed
//   const returnToOriginalSpeed = (itemId, originalSpeed) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('returnToOriginalSpeed: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) => {
//         if (item.id === itemId) {
//           return {
//             ...item,
//             deliverySpeed: originalSpeed,
//             deliverySurcharge: 0
//           };
//         }
//         return item;
//       });
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Increment quantity
//   const incrementQuantity = (itemId) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('incrementQuantity: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems.map((item) =>
//         item.id === itemId ? { ...item, quantity: (item.quantity || 1) + 1 } : item
//       );
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Decrement quantity
//   const decrementQuantity = (itemId) => {
//     setCartItems((prevItems) => {
//       if (!Array.isArray(prevItems)) {
//         console.error('decrementQuantity: prevItems is not an array:', prevItems);
//         return [];
//       }
//       const updatedItems = prevItems
//         .map((item) =>
//           item.id === itemId
//             ? { ...item, quantity: Math.max((item.quantity || 1) - 1, 1) }
//             : item
//         )
//         .filter((item) => item.quantity > 0);
//       saveCart(updatedItems);
//       return updatedItems;
//     });
//   };

//   // Remove item
//   const removeItem = async (itemId) => {
//     const currentItems = Array.isArray(cartItems) ? [...cartItems] : [];
//     const updatedItems = currentItems.filter((item) => item.id !== itemId);
//     localStorage.setItem('cartItems', JSON.stringify(updatedItems));
//     setCartItems(updatedItems);
//     if (userId) {
//       try {
//         const cartDocRef = doc(db, 'carts', userId);
//         const itemsObject = {};
//         updatedItems.forEach(item => {
//           if (item && item.id) {
//             itemsObject[item.id] = {
//               ...item,
//               updatedAt: new Date()
//             };
//           }
//         });
//         await updateDoc(cartDocRef, {
//           items: itemsObject,
//           updatedAt: new Date()
//         });
//         console.log("Cart updated in Firestore after removal:", itemsObject);
//         await updateDoc(cartDocRef, {
//           [`items.${itemId}`]: deleteField()
//         });
//       } catch (error) {
//         console.error('Error removing item from Firestore:', error);
//       }
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Calculate subtotal (without delivery surcharges)
//   const calculateSubtotal = () => {
//     if (!Array.isArray(cartItems)) {
//       console.error('calculateSubtotal: cartItems is not an array:', cartItems);
//       return 0;
//     }
//     return cartItems.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
//   };

//   // Calculate total delivery surcharges
//   const calculateTotalSurcharges = () => {
//     if (!Array.isArray(cartItems)) {
//       console.error('calculateTotalSurcharges: cartItems is not an array:', cartItems);
//       return 0;
//     }
//     return cartItems.reduce((total, item) => {
//       const surcharge = item.deliverySurcharge || 0;
//       return total + (surcharge * (item.quantity || 1));
//     }, 0);
//   };

//   // Calculate coupon discount
//   const calculateCouponDiscount = () => {
//     if (!couponApplied) return 0;
//     return calculateSubtotal() * 0.02; // 2% discount
//   };

//   // Calculate total including surcharges and discounts
//   const calculateTotal = () => {
//     const subtotal = calculateSubtotal();
//     const surcharges = calculateTotalSurcharges();
//     const couponDiscount = calculateCouponDiscount();
//     return subtotal + surcharges - couponDiscount - pointsDiscountAmount;
//   };

//   // Format currency
//   const formatCurrency = (amount) => {
//     return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
//   };

//   // Clear cart after successful order
//   const clearCart = async () => {
//     localStorage.removeItem('cartItems');
//     setCartItems([]);
//     if (userId) {
//       try {
//         const cartDocRef = doc(db, 'carts', userId);
//         await setDoc(cartDocRef, {
//           items: {},
//           updatedAt: new Date()
//         });
//         console.log("Cart cleared in Firestore");
//       } catch (error) {
//         console.error('Error clearing cart from Firestore:', error);
//       }
//     }
//     const event = new Event('cartUpdated');
//     window.dispatchEvent(event);
//   };

//   // Handle proceed to checkout
//   const handleProceedToCheckout = () => {
//     // Check if ordering is allowed based on time
//     if (!isOrderingAllowed) {
//       setShowTimeAlert(true);
//       return;
//     }
    
//     const token = localStorage.getItem('authToken');
//     if (token) {
//       navigate('/checkout');
//     } else {
//       navigate('/login', { state: { from: '/checkout' } });
//     }
//   };

//   // Close time alert modal
//   const closeTimeAlert = () => {
//     setShowTimeAlert(false);
//   };

//   // Handle start shopping
//   const handleStartShopping = () => {
//     navigate('/products');
//   };

//   // Fix image URL
//   const getImageUrl = (image) => {
//     if (!image) return 'https://via.placeholder.com/100x100?text=Product';
//     if (typeof image === 'string' && image.startsWith('https://firebasestorage.googleapis.com')) {
//       return image;
//     }
//     if (image.startsWith('http')) return image;
//     if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) {
//       return image.imageUrl;
//     }
//     return `/images/${image}`;
//   };

//   // Get delivery icon
//   const getDeliveryIcon = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return '⚡';
//       case 'express':
//         return '🚀';
//       case 'late':
//         return '🐌';
//       case 'normal':
//       default:
//         return '🚚';
//     }
//   };

//   // Get delivery title
//   const getDeliveryTitle = (speed) => {
//     switch (speed) {
//       case 'quick':
//         return 'Quick Delivery';
//       case 'express':
//         return 'Express Delivery';
//       case 'late':
//         return 'Eco Delivery';
//       case 'normal':
//       default:
//         return 'Standard Delivery';
//     }
//   };

//   // Group cart items
//   const groupedCartItems = () => {
//     const grouped = {
//       quick: [],
//       normal: [],
//       late: []
//     };
//     if (!Array.isArray(cartItems)) {
//       console.error('groupedCartItems: cartItems is not an array:', cartItems);
//       return grouped;
//     }
//     cartItems.forEach(item => {
//       const speed = item.deliverySpeed || 'normal';
//       if (grouped[speed]) {
//         grouped[speed].push(item);
//       } else {
//         grouped.normal.push(item);
//       }
//     });
//     return grouped;
//   };

//   // Check if there are items with non-original delivery speeds in a category
//   const hasNonOriginalItems = (items) => {
//     return items.some(item => item.deliverySpeed !== item.originalDeliverySpeed);
//   };

//   if (loading) {
//     return (
//       <div className="cart-loading">
//         <p>Loading your cart...</p>
//       </div>
//     );
//   }

//   const handleGoBack = (e) => {
//     e.preventDefault();
//     e.stopPropagation();
//     navigate(-1, { replace: true });
//   };

//   const grouped = groupedCartItems();
//   const subtotal = calculateSubtotal();
//   const totalSurcharges = calculateTotalSurcharges();
//   const couponDiscount = calculateCouponDiscount();
//   console.log("Grouped items:", grouped);
//   console.log("Subtotal:", subtotal);
//   console.log("Total surcharges:", totalSurcharges);
//   console.log("Points discount:", pointsDiscountAmount);

//   return (
//     <div className="cart-container">
//       {/* Time restriction alert modal */}
//       {showTimeAlert && (
//         <div className="time-alert-overlay">
//           <div className="time-alert-modal">
//             <p>Process closed for today, book order tomorrow.</p>
//             <button className="ok-button" onClick={closeTimeAlert}>OK</button>
//           </div>
//         </div>
//       )}
      
//       <button className="go-back-btn2" onClick={handleGoBack}>
//         ← Go Back
//       </button>
//       {cartItems.length === 0 ? (
//         <div className="cart-empty">
//           <div className="cart-empty-bg"></div>
//           <svg
//             className="cart-icon"
//             width="80"
//             height="80"
//             viewBox="0 0 24 24"
//             fill="none"
//             stroke="currentColor"
//             strokeWidth="2"
//           >
//             <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
//           </svg>
//           <h2 className="cart-title">Your Cart is Empty</h2>
//           <p className="cart-subtitle">
//             Looks like you haven't added anything to your cart yet. Let's get started!
//           </p>
//           <button className="cart-button1" onClick={handleStartShopping}>
//             Start Shopping Now
//           </button>
//         </div>
//       ) : (
//         <div className="cart-content">
//           <h2 className="cart-title">Your Cart ({cartItems.length} {cartItems.length === 1 ? 'Item' : 'Items'})</h2>
//           {/* Quick Delivery Section */}
//           {grouped.quick.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section quick-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('quick')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Quick Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivered today</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('quick', 'normal')}
//                     aria-label="Change all to standard delivery"
//                     title="Move all to Standard Delivery"
//                   >
//                     <span className="btn-icon">↓</span>
//                     <span className="btn-label">Move to Standard</span>
//                   </button>
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('quick', 'late')}
//                     aria-label="Change all to eco delivery"
//                     title="Move all to Eco Delivery"
//                   >
//                     <span className="btn-icon">↓↓</span>
//                     <span className="btn-label">Move to Eco</span>
//                   </button>
//                   {hasNonOriginalItems(grouped.quick) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('quick')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.quick.length} {grouped.quick.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.quick.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'quick' && (
//                           <>
//                             {item.deliverySpeed !== 'normal' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                 aria-label="Change to standard delivery"
//                                 title="Move to Standard Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Standard</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           {/* Standard Delivery Section */}
//           {grouped.normal.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section normal-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('normal')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Standard Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivery by next day</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   {grouped.normal.some(item => item.originalDeliverySpeed === 'normal') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('normal', 'quick')}
//                       aria-label="Change all to quick delivery"
//                       title="Move all to Quick Delivery (+₹80 each for standard origin items)"
//                     >
//                       <span className="btn-icon">↑</span>
//                       <span className="btn-label">Move to Quick +₹80</span>
//                     </button>
//                   )}
//                   <button
//                     className="delivery-btn down with-label"
//                     onClick={() => changeAllDeliverySpeed('normal', 'late')}
//                     aria-label="Change all to eco delivery"
//                     title="Move all to Eco Delivery"
//                   >
//                     <span className="btn-icon">↓</span>
//                     <span className="btn-label">Move to Eco</span>
//                   </button>
//                   {hasNonOriginalItems(grouped.normal) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('normal')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.normal.length} {grouped.normal.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.normal.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'normal' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed === 'quick' && (
//                           <>
//                             {item.deliverySpeed !== 'normal' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                 aria-label="Change to standard delivery"
//                                 title="Move to Standard Delivery"
//                               >
//                                 <span className="btn-icon">↓</span>
//                                 <span className="btn-label">Standard</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== 'late' && (
//                               <button
//                                 className="delivery-btn down with-label"
//                                 onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                 aria-label="Change to eco delivery"
//                                 title="Move to Eco Delivery"
//                               >
//                                 <span className="btn-icon">↓↓</span>
//                                 <span className="btn-label">Eco</span>
//                               </button>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed === 'late' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                               aria-label="Change to standard delivery"
//                               title="Move to Standard Delivery (+₹60)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Standard +₹60</span>
//                             </button>
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           {/* Eco Delivery Section */}
//           {grouped.late.length > 0 && (
//             <div className="delivery-group">
//               <div className="delivery-section late-delivery-section">
//                 <div className="delivery-icon">{getDeliveryIcon('late')}</div>
//                 <div className="delivery-info">
//                   <h3 className="delivery-title">Eco Delivery</h3>
//                   <p className="delivery-subtitle" style={{ display: 'block', color: 'black' }}>Delivery by 2 days</p>
//                 </div>
//                 <div className="delivery-controls-section">
//                   {grouped.late.some(item => item.originalDeliverySpeed === 'late') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('late', 'quick')}
//                       aria-label="Change all to quick delivery"
//                       title="Move all to Quick Delivery (+₹80 each for eco origin items)"
//                     >
//                       <span className="btn-icon">↑↑</span>
//                       <span className="btn-label">Move to Quick +₹80</span>
//                     </button>
//                   )}
//                   {grouped.late.some(item => item.originalDeliverySpeed === 'late') && (
//                     <button
//                       className="delivery-btn up with-label"
//                       onClick={() => changeAllDeliverySpeed('late', 'normal')}
//                       aria-label="Change all to standard delivery"
//                       title="Move all to Standard Delivery (+₹60 each for eco origin items)"
//                     >
//                       <span className="btn-icon">↑</span>
//                       <span className="btn-label">Move to Standard +₹60</span>
//                     </button>
//                   )}
//                   {hasNonOriginalItems(grouped.late) && (
//                     <button
//                       className="delivery-btn return-all with-label"
//                       onClick={() => returnAllToOriginalSpeed('late')}
//                       aria-label="Return all items to original delivery speed"
//                       title="Return all items to original delivery speed"
//                     >
//                       <span className="btn-icon">↩</span>
//                       <span className="btn-label">Return All</span>
//                     </button>
//                   )}
//                 </div>
//                 <div className="delivery-count">{grouped.late.length} {grouped.late.length === 1 ? 'item' : 'items'}</div>
//               </div>
//               <div className="cart-items">
//                 {grouped.late.map((item) => (
//                   <div key={item.id} className="cart-item">
//                     <img
//                       src={getImageUrl(item.imageUrl || item.image)}
//                       alt={item.name}
//                       className="cart-item-image"
//                       onError={(e) => {
//                         console.error("Image failed to load:", item.imageUrl || item.image);
//                         e.target.src = 'https://via.placeholder.com/100x100?text=Product';
//                       }}
//                     />
//                     <div className="cart-item-details">
//                       <h3 className="cart-item-name">{item.name}</h3>
//                       <div className="cart-item-price-container">
//                         <p className="cart-item-price">
//                           ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
//                         </p>
//                         {item.deliverySurcharge > 0 && (
//                           <p className="cart-item-surcharge">
//                             +₹{(item.deliverySurcharge * (item.quantity || 1)).toLocaleString('en-IN')} delivery surcharge
//                           </p>
//                         )}
//                       </div>
//                       <div className="cart-item-quantity">
//                         <button
//                           className="quantity-btn decrease"
//                           onClick={() => decrementQuantity(item.id)}
//                           aria-label="Decrease quantity"
//                         >
//                           -
//                         </button>
//                         <span className="quantity-value">{item.quantity || 1}</span>
//                         <button
//                           className="quantity-btn increase"
//                           onClick={() => incrementQuantity(item.id)}
//                           aria-label="Increase quantity"
//                         >
//                           +
//                         </button>
//                       </div>
//                       <div className="item-delivery-controls">
//                         {item.originalDeliverySpeed === 'late' && (
//                           <>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                               aria-label="Change to quick delivery"
//                               title="Move to Quick Delivery (+₹80)"
//                             >
//                               <span className="btn-icon">↑↑</span>
//                               <span className="btn-label">Quick +₹80</span>
//                             </button>
//                             <button
//                               className="delivery-btn up with-label"
//                               onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                               aria-label="Change to standard delivery"
//                               title="Move to Standard Delivery (+₹60)"
//                             >
//                               <span className="btn-icon">↑</span>
//                               <span className="btn-label">Standard +₹60</span>
//                             </button>
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                         {item.originalDeliverySpeed !== 'late' && (
//                           <>
//                             {item.originalDeliverySpeed === 'quick' && (
//                               <>
//                                 {item.deliverySpeed !== 'normal' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'normal')}
//                                     aria-label="Change to standard delivery"
//                                     title="Move to Standard Delivery"
//                                   >
//                                     <span className="btn-icon">↓</span>
//                                     <span className="btn-label">Standard</span>
//                                   </button>
//                                 )}
//                                 {item.deliverySpeed !== 'late' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                     aria-label="Change to eco delivery"
//                                     title="Move to Eco Delivery"
//                                   >
//                                     <span className="btn-icon">↓↓</span>
//                                     <span className="btn-label">Eco</span>
//                                   </button>
//                                 )}
//                               </>
//                             )}
//                             {item.originalDeliverySpeed === 'normal' && (
//                               <>
//                                 <button
//                                   className="delivery-btn up with-label"
//                                   onClick={() => changeDeliverySpeed(item.id, 'quick')}
//                                   aria-label="Change to quick delivery"
//                                   title="Move to Quick Delivery (+₹80)"
//                                 >
//                                   <span className="btn-icon">↑</span>
//                                   <span className="btn-label">Quick +₹80</span>
//                                 </button>
//                                 {item.deliverySpeed !== 'late' && (
//                                   <button
//                                     className="delivery-btn down with-label"
//                                     onClick={() => changeDeliverySpeed(item.id, 'late')}
//                                     aria-label="Change to eco delivery"
//                                     title="Move to Eco Delivery"
//                                   >
//                                     <span className="btn-icon">↓</span>
//                                     <span className="btn-label">Eco</span>
//                                   </button>
//                                 )}
//                               </>
//                             )}
//                             {item.deliverySpeed !== item.originalDeliverySpeed && (
//                               <button
//                                 className="delivery-btn return with-label"
//                                 onClick={() => returnToOriginalSpeed(item.id, item.originalDeliverySpeed)}
//                                 aria-label="Return to original delivery speed"
//                                 title="Return to original delivery speed"
//                               >
//                                 <span className="btn-icon">↩</span>
//                                 <span className="btn-label">Return</span>
//                               </button>
//                             )}
//                           </>
//                         )}
//                       </div>
//                     </div>
//                     <button
//                       className="cart-item-remove"
//                       onClick={() => removeItem(item.id)}
//                     >
//                       Remove
//                     </button>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           )}
//           <div className="cart-summary">
//             {/* Discounts section */}
//             <div className="cart-discounts">
//               <h3>Discounts & Rewards</h3>
              
              
//               {/* Points discount */}
//               {userId ? (
//                 <div className="discount-option">
//                   <label className="discount-checkbox">
//                     <input
//                       type="checkbox"
//                       checked={usePointsDiscount}
//                       onChange={handlePointsToggle}
//                       disabled={availablePoints < 100}
//                     />
//                     <span>
//                       Use loyalty points ({availablePoints} available)
//                     </span>
//                   </label>
//                   {usePointsDiscount && pointsMessage && (
//                     <div className="points-info">
//                       {pointsMessage}
//                     </div>
//                   )}
//                   {availablePoints < 100 && (
//                     <div className="insufficient-points">
//                       Minimum 100 points required to redeem
//                     </div>
//                   )}
//                 </div>
//               ) : (
//                 <div className="discount-option">
//                   <button 
//                     className="login-for-points-btn"
//                     onClick={() => navigate('/login', { state: { from: '/cart' } })}
//                   >
//                     Log in to use your loyalty points
//                   </button>
//                 </div>
//               )}
              
              
//             </div>
            
//             <div className="cart-summary-details">
//               <div className="summary-row">
//                 <span>Subtotal:</span>
//                 <span>{formatCurrency(subtotal)}</span>
//               </div>
//               {couponDiscount > 0 && (
//                 <div className="summary-row discount">
//                   <span>Coupon Discount (2%):</span>
//                   <span>-{formatCurrency(couponDiscount)}</span>
//                 </div>
//               )}
//               {pointsDiscountAmount > 0 && (
//                 <div className="summary-row points-discount">
//                   <span>Points Discount:</span>
//                   <span>-{formatCurrency(pointsDiscountAmount)}</span>
//                 </div>
//               )}
//               {totalSurcharges > 0 && (
//                 <div className="summary-row surcharge">
//                   <span>Delivery Surcharges:</span>
//                   <span>+{formatCurrency(totalSurcharges)}</span>
//                 </div>
//               )}
//               <div className="summary-row total">
//                 <span>Total:</span>
//                 <span>{formatCurrency(calculateTotal())}</span>
//               </div>
//             </div>
            
//             <button 
//               className="checkout-btn" 
//               onClick={handleProceedToCheckout}
//             >
//               Proceed to Checkout
//             </button>
            
//             {orderError && (
//               <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
//                 {orderError}
//               </div>
//             )}
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default Cart;



import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { doc, getDoc, setDoc, updateDoc, deleteField, collection, getDocs, query, where } from 'firebase/firestore';
import { db, auth } from '../../firebase/firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import './Cart.css';

const Cart = () => {
  const [cartItems, setCartItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [userId, setUserId] = useState(null);
  const [orders, setOrders] = useState([]);
  const [loadingOrders, setLoadingOrders] = useState(true);
  const [isOrderHistoryExpanded, setIsOrderHistoryExpanded] = useState(false);
  
  // Error state
  const [orderError, setOrderError] = useState(null);
  const [userData, setUserData] = useState(null);
  
  // Points and coupon states
  const [usePointsDiscount, setUsePointsDiscount] = useState(false);
  const [pointsDiscountAmount, setPointsDiscountAmount] = useState(0);
  const [availablePoints, setAvailablePoints] = useState(0);
  const [pointsMessage, setPointsMessage] = useState('');
  const [pointsEarned, setPointsEarned] = useState(0);
  const [couponApplied, setCouponApplied] = useState(false);
  const [discountAmount, setDiscountAmount] = useState(0);
  
  const navigate = useNavigate();
  const location = useLocation();

  // Fetch cart from Firestore (memoized)
  const fetchCartFromFirestore = useCallback(async (uid) => {
    try {
      console.log("Fetching cart from Firestore for user:", uid);
      const cartDocRef = doc(db, 'carts', uid);
      const cartDoc = await getDoc(cartDocRef);
      if (cartDoc.exists()) {
        const cartData = cartDoc.data();
        console.log("Firestore cart data:", cartData);
        if (cartData.items && Object.keys(cartData.items).length > 0) {
          const cartItemsArray = Object.values(cartData.items || {});
          console.log("Firestore cart items array:", cartItemsArray);
          const validItems = cartItemsArray
            .filter(item => {
              console.log("Cart item before validation:", item);
              const isValid = item && item.id && item.name && item.price;
              if (!isValid) {
                console.log("Invalid item found:", item);
                console.log("Missing properties:", {
                  hasItem: !!item,
                  hasId: item && !!item.id,
                  hasName: item && !!item.name,
                  hasPrice: item && !!item.price
                });
              }
              return isValid;
            })
            .map(item => {
              return {
                ...item,
                quantity: item.quantity || 1,
                couponApplied: item.couponApplied || false,
                pointsDiscount: item.pointsDiscount || 0,
                pointsUsed: item.pointsUsed || 0
              };
            });
          console.log("Loaded items from Firestore:", validItems);
          if (validItems.length > 0) {
            setCartItems(validItems);
            localStorage.setItem('cartItems', JSON.stringify(validItems));
            console.log("Updated cart with Firestore items:", validItems.length);
            
            // Check if points discount was applied
            const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
            if (anyPointsUsed) {
              setUsePointsDiscount(true);
            }
            
            // Check if coupon was applied
            const anyCouponApplied = validItems.some(item => item.couponApplied);
            setCouponApplied(anyCouponApplied);
          } else {
            console.log("No valid items found in Firestore, checking localStorage");
            fetchCartFromLocalStorage();
          }
        } else {
          console.log("No items in Firestore cart, checking localStorage");
          fetchCartFromLocalStorage();
        }
      } else {
        console.log("Cart document does not exist in Firestore, checking localStorage");
        fetchCartFromLocalStorage();
      }
    } catch (error) {
      console.error('Error fetching cart from Firestore:', error);
      fetchCartFromLocalStorage();
    }
  }, []);

  // Fetch cart from localStorage (memoized)
  const fetchCartFromLocalStorage = useCallback(() => {
    console.log("Fetching cart from localStorage");
    const storedCart = localStorage.getItem('cartItems');
    console.log("Raw localStorage cartItems:", storedCart);
    
    if (storedCart) {
      try {
        const parsedCart = JSON.parse(storedCart);
        console.log("Parsed localStorage cartItems:", parsedCart);
        let itemsToProcess = parsedCart;
        if (!Array.isArray(parsedCart) && parsedCart && typeof parsedCart === 'object' && parsedCart.items) {
          console.log("Found items property in localStorage cart object");
          itemsToProcess = parsedCart.items;
        }
        if (!Array.isArray(itemsToProcess) && itemsToProcess && typeof itemsToProcess === 'object') {
          console.log("Converting object to array from localStorage");
          itemsToProcess = Object.values(itemsToProcess);
        }
        if (!Array.isArray(itemsToProcess)) {
          console.log("itemsToProcess is not an array, setting to empty array");
          itemsToProcess = [];
        }
        const validItems = itemsToProcess
          .filter(item => {
            console.log("Cart item before validation:", item);
            const isValid = item && item.id && item.name;
            if (!isValid) {
              console.log("Invalid item found:", item);
              console.log("Missing properties:", {
                hasItem: !!item,
                hasId: item && !!item.id,
                hasName: item && !!item.name
              });
            }
            return isValid;
          })
          .map(item => {
            return {
              ...item,
              price: item.price || 0,
              originalPrice: item.originalPrice || item.price || 0, // Ensure originalPrice exists
              quantity: item.quantity || 1,
              couponApplied: item.couponApplied || false,
              pointsDiscount: item.pointsDiscount || 0,
              pointsUsed: item.pointsUsed || 0
            };
          });
        console.log("Loaded items from localStorage:", validItems);
        console.log("Valid items count:", validItems.length);
        if (validItems.length > 0) {
          setCartItems(validItems);
          localStorage.setItem('cartItems', JSON.stringify(validItems));
          console.log("Updated localStorage with normalized items");
          
          // Check if points discount was applied
          const anyPointsUsed = validItems.some(item => item.pointsUsed > 0);
          if (anyPointsUsed) {
            setUsePointsDiscount(true);
          }
          
          // Check if coupon was applied
          const anyCouponApplied = validItems.some(item => item.couponApplied);
          setCouponApplied(anyCouponApplied);
        } else {
          console.log("No valid items found in localStorage");
          setCartItems([]);
        }
      } catch (error) {
        console.error('Error parsing cart items from localStorage:', error);
        setCartItems([]);
      }
    } else {
      console.log("No cart items in localStorage, setting to empty.");
      setCartItems([]);
    }
  }, []);

  // Fetch orders from Firestore (memoized)
  const fetchOrdersFromFirestore = useCallback(async (uid) => {
    setLoadingOrders(true);
    try {
      console.log("Fetching orders from Firestore for user:", uid);
      const ordersCollectionRef = collection(db, 'orders');
      const q = query(ordersCollectionRef, where('userId', '==', uid));
      const ordersSnapshot = await getDocs(q);
      console.log("Firestore orders snapshot empty?", ordersSnapshot.empty);
      console.log("Number of orders fetched:", ordersSnapshot.docs.length);
      if (ordersSnapshot.empty) {
        console.log("No orders found for user in Firestore at path 'orders' with userId:", uid);
        setOrders([]);
        return;
      }
      const ordersList = ordersSnapshot.docs.map(doc => {
        const data = doc.data();
        console.log(`Order document ${doc.id} data:`, data);
        const items = data.cartItems || data.items || data.orderItems || [];
        const total = data.total !== undefined ? data.total : 0;
        const status = data.status || 'pending';
        const isValidItems = Array.isArray(items) && items.every(item => item.id && item.name);
        if (!isValidItems) {
          console.warn(`Order ${doc.id} has invalid or missing items:`, items);
          return null;
        }
        const normalizedItems = items.map(item => ({
          id: item.id,
          name: item.name,
          price: item.price || 0,
          quantity: item.quantity || 1,
          image: item.image || item.imageUrl,
          imageUrl: item.imageUrl || item.image,
        }));
        const date = data.orderDate || data.date;
        const parsedDate = date && typeof date.toDate === 'function' ? date : new Date();
        if (!date || (typeof date.toDate !== 'function' && isNaN(new Date(date).getTime()))) {
          console.warn(`Order ${doc.id} has invalid date field, using current date as fallback:`, date);
        }
        return {
          id: doc.id,
          items: normalizedItems,
          total,
          status,
          date: parsedDate,
        };
      }).filter(order => order !== null);
      console.log("Processed orders list:", ordersList);
      if (ordersList.length === 0) {
        console.log("No valid orders after processing. Check field names and data structure.");
        setOrders([]);
        return;
      }
      const sortedOrders = ordersList.sort((a, b) => {
        const dateA = a.date.toDate ? a.date.toDate() : new Date(a.date);
        const dateB = b.date.toDate ? b.date.toDate() : new Date(b.date);
        return dateB - dateA;
      });
      console.log("Sorted orders:", sortedOrders);
      setOrders(sortedOrders);
      console.log("Orders state updated with:", sortedOrders);
    } catch (error) {
      console.error('Error fetching orders from Firestore:', error);
      setOrders([]);
    } finally {
      setLoadingOrders(false);
    }
  }, []);

  // Check authentication, load data, and handle post-checkout refresh
  useEffect(() => {
    console.log("Cart component mounted, checking auth state");
    const quickCheck = localStorage.getItem('cartItems');
    if (quickCheck) {
      try {
        const parsedItems = JSON.parse(quickCheck);
        if (Array.isArray(parsedItems) && parsedItems.length > 0) {
          console.log("Found cart items in localStorage, displaying temporarily:", parsedItems.length);
          setCartItems(parsedItems);
        }
      } catch (e) {
        console.error("Error parsing localStorage cart for quick display:", e);
      }
    }
    let authInitialized = false;
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      console.log("Auth state changed:", user ? user.uid : "No user");
      if (!authInitialized) {
        authInitialized = true;
        setLoading(false);
      }
      if (user) {
        console.log("User is authenticated:", user.uid);
        setUserId(user.uid);
        fetchCartFromFirestore(user.uid);
        fetchOrdersFromFirestore(user.uid);
        
        // Load user data for points system
        try {
          const userDocRef = query(
            collection(db, 'users'),
            where('email', '==', user.email)
          );
          const userSnapshot = await getDocs(userDocRef);
          if (!userSnapshot.empty) {
            const userData = userSnapshot.docs[0].data();
            const userPoints = userData.points || 0;
            setAvailablePoints(userPoints);
            setUserData({
              uid: user.uid,
              email: user.email,
              name: userData.name || user.displayName || 'User',
              phone: userData.phone || '',
              deliveryAddress: userData.deliveryAddress || '',
              points: userPoints
            });
          } else {
            // Fallback to stored user data in localStorage
            const storedUserData = localStorage.getItem('userData');
            if (storedUserData) {
              const parsedUserData = JSON.parse(storedUserData);
              setUserData(parsedUserData);
              setAvailablePoints(parsedUserData.points || 0);
            }
          }
        } catch (error) {
          console.error("Error loading user data:", error);
        }
      } else {
        console.log("User is not authenticated, using localStorage");
        setUserId(null);
        fetchCartFromLocalStorage();
        if (authInitialized) {
          setOrders([]);
          setLoadingOrders(false);
        }
        
        // Try to load user data from localStorage
        const storedUserData = localStorage.getItem('userData');
        if (storedUserData) {
          try {
            const parsedUserData = JSON.parse(storedUserData);
            setUserData(parsedUserData);
            setAvailablePoints(parsedUserData.points || 0);
          } catch (error) {
            console.error("Error parsing stored user data:", error);
          }
        }
      }
    });

    // Listen for cart update events
    const handleCartUpdate = () => {
      console.log("Cart update event detected");
      if (userId) {
        fetchCartFromFirestore(userId);
      } else {
        fetchCartFromLocalStorage();
      }
    };

    window.addEventListener('cartUpdated', handleCartUpdate);

    return () => {
      unsubscribe();
      window.removeEventListener('cartUpdated', handleCartUpdate);
    };
  }, [fetchCartFromFirestore, fetchCartFromLocalStorage, fetchOrdersFromFirestore]);

  // Calculate points discount and update messages
  useEffect(() => {
    if (cartItems && cartItems.length > 0) {
      const baseSubtotal = calculateSubtotal();
      const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
      setDiscountAmount(couponDiscount);
      
      // First check if any existing points are already applied in cart items
      const existingPointsUsed = cartItems.reduce((total, item) => {
        return total + (item.pointsUsed || 0);
      }, 0);
      
      let pointsDiscount = 0;
      
      if (existingPointsUsed > 0) {
        // If points are already applied, use that exact value
        pointsDiscount = existingPointsUsed / 100;
        setPointsMessage(`Using ${existingPointsUsed} points for ₹${pointsDiscount.toFixed(2)} discount`);
        setUsePointsDiscount(true);
      } else if (usePointsDiscount && availablePoints > 0) {
        // Otherwise calculate new discount if enabled
        // 100 points = ₹1 discount
        const maxPointsDiscount = availablePoints / 100;
        const maxAllowedDiscount = baseSubtotal - couponDiscount;
        pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        
        if (pointsDiscount > 0) {
          setPointsMessage(`Using ${Math.floor(pointsDiscount * 100)} points for ₹${pointsDiscount.toFixed(2)} discount`);
        } else {
          setPointsMessage('Not enough points for discount');
        }
      } else {
        setPointsMessage('');
      }
      
      setPointsDiscountAmount(pointsDiscount);
      
      // Calculate points to be earned (10% of original price)
      const totalOriginalPrice = cartItems.reduce((total, item) => {
        const originalPrice = item.originalPrice || item.price;
        return total + (originalPrice * item.quantity);
      }, 0);
      
      const estimatedPoints = Math.floor(totalOriginalPrice * 0.1);
      setPointsEarned(estimatedPoints);
    }
  }, [cartItems, usePointsDiscount, availablePoints, couponApplied]);

  // Handle post-checkout order refresh
  useEffect(() => {
    if (userId && location.state && location.state.fromCheckout) {
      console.log("Detected return from checkout, refreshing orders for user:", userId);
      fetchOrdersFromFirestore(userId);
      navigate(location.pathname, { state: {}, replace: true });
    }
  }, [location.state, userId, fetchOrdersFromFirestore, navigate, location.pathname]);

  // Save cart to Firestore and localStorage
  const saveCart = async (updatedItems) => {
    console.log("Saving cart items:", updatedItems);
    if (!Array.isArray(updatedItems)) {
      console.error('saveCart: updatedItems is not an array:', updatedItems);
      return;
    }
    localStorage.setItem('cartItems', JSON.stringify(updatedItems));
    console.log("Saved to localStorage");
    if (userId) {
      try {
        console.log("Saving to Firestore for user:", userId);
        const cartDocRef = doc(db, 'carts', userId);
        const itemsObject = {};
        updatedItems.forEach(item => {
          if (item && item.id) {
            itemsObject[item.id] = {
              ...item,
              updatedAt: new Date()
            };
          }
        });
        console.log("Saving these items to Firestore:", itemsObject);
        const cartDoc = await getDoc(cartDocRef);
        if (cartDoc.exists()) {
          await updateDoc(cartDocRef, {
            items: itemsObject,
            updatedAt: new Date()
          });
          console.log("Cart updated in Firestore:", Object.keys(itemsObject).length, "items");
        } else {
          await setDoc(cartDocRef, {
            items: itemsObject,
            createdAt: new Date(),
            updatedAt: new Date()
          });
          console.log("New cart created in Firestore:", Object.keys(itemsObject).length, "items");
        }
      } catch (error) {
        console.error('Error saving cart to Firestore:', error);
      }
    } else {
      console.log("User not authenticated, not saving to Firestore");
    }
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  // Toggle coupon application
  const handleCouponToggle = () => {
    setCouponApplied(!couponApplied);
    
    setCartItems(prevItems => {
      const updatedItems = prevItems.map(item => ({
        ...item,
        couponApplied: !couponApplied
      }));
      saveCart(updatedItems);
      return updatedItems;
    });
  };

  // Toggle points discount
  const handlePointsToggle = () => {
    if (!userId) {
      // Redirect to login if not logged in
      navigate('/login', { state: { from: '/cart' } });
      return;
    }
    
    const newUsePointsDiscount = !usePointsDiscount;
    setUsePointsDiscount(newUsePointsDiscount);
    
    setCartItems(prevItems => {
      if (!Array.isArray(prevItems)) {
        console.error('handlePointsToggle: prevItems is not an array:', prevItems);
        return [];
      }
      
      const baseSubtotal = calculateSubtotal();
      const couponDiscount = couponApplied ? baseSubtotal * 0.02 : 0;
      let pointsDiscount = 0;
      let pointsToUse = 0;
      
      if (newUsePointsDiscount && availablePoints > 0) {
        const maxPointsDiscount = availablePoints / 100;
        const maxAllowedDiscount = baseSubtotal - couponDiscount;
        pointsDiscount = Math.min(maxPointsDiscount, maxAllowedDiscount);
        pointsToUse = Math.floor(pointsDiscount * 100);
      }
      
      // Apply the exact same points discount to all items to maintain consistency
      const totalItemsPrice = prevItems.reduce((total, item) => total + (item.price * (item.quantity || 1)), 0);
      
      const updatedItems = prevItems.map(item => {
        // Calculate this item's proportion of the total price
        const itemPrice = item.price * (item.quantity || 1);
        const proportion = itemPrice / totalItemsPrice;
        
        // Assign proportional points to this item
        const itemPoints = newUsePointsDiscount ? Math.floor(pointsToUse * proportion) : 0;
        const itemDiscount = itemPoints / 100;
        
        return {
          ...item,
          pointsDiscount: itemDiscount,
          pointsUsed: itemPoints
        };
      });
      
      saveCart(updatedItems);
      setPointsDiscountAmount(pointsDiscount);
      
      return updatedItems;
    });
  };

  // Update user points balance in Firestore
  const updateUserPoints = async (newPointsBalance) => {
    if (!userId) return;
    
    try {
      const userRef = doc(db, 'users', userId);
      await updateDoc(userRef, {
        points: newPointsBalance
      });
      
      setAvailablePoints(newPointsBalance);
      
      if (userData) {
        const updatedUserData = {
          ...userData,
          points: newPointsBalance
        };
        setUserData(updatedUserData);
        localStorage.setItem('userData', JSON.stringify(updatedUserData));
      }
      
      console.log(`Updated user points balance to ${newPointsBalance}`);
      
      // Dispatch an event to refresh profile page if it's open
      const refreshEvent = new Event('refreshProfile');
      window.dispatchEvent(refreshEvent);
    } catch (error) {
      console.error("Error updating user points:", error);
    }
  };

  // Change delivery speed for a single item
  const changeDeliverySpeed = (itemId, newSpeed) => {
    // Removed - all items now use normal delivery
  };

  // Change delivery speed for all items in a category (bulk change)
  const changeAllDeliverySpeed = (currentSpeed, newSpeed) => {
    // Removed - all items now use normal delivery
  };

  // Return all items in a delivery speed category to their original speeds
  const returnAllToOriginalSpeed = (speedCategory) => {
    // Removed - all items now use normal delivery
  };

  // Return to original delivery speed
  const returnToOriginalSpeed = (itemId, originalSpeed) => {
    // Removed - all items now use normal delivery
  };

  // Increment quantity
  const incrementQuantity = (itemId) => {
    setCartItems((prevItems) => {
      if (!Array.isArray(prevItems)) {
        console.error('incrementQuantity: prevItems is not an array:', prevItems);
        return [];
      }
      const updatedItems = prevItems.map((item) =>
        item.id === itemId ? { ...item, quantity: (item.quantity || 1) + 1 } : item
      );
      saveCart(updatedItems);
      return updatedItems;
    });
  };

  // Decrement quantity
  const decrementQuantity = (itemId) => {
    setCartItems((prevItems) => {
      if (!Array.isArray(prevItems)) {
        console.error('decrementQuantity: prevItems is not an array:', prevItems);
        return [];
      }
      const updatedItems = prevItems
        .map((item) =>
          item.id === itemId
            ? { ...item, quantity: Math.max((item.quantity || 1) - 1, 1) }
            : item
        )
        .filter((item) => item.quantity > 0);
      saveCart(updatedItems);
      return updatedItems;
    });
  };

  // Remove item
  const removeItem = async (itemId) => {
    const currentItems = Array.isArray(cartItems) ? [...cartItems] : [];
    const updatedItems = currentItems.filter((item) => item.id !== itemId);
    localStorage.setItem('cartItems', JSON.stringify(updatedItems));
    setCartItems(updatedItems);
    if (userId) {
      try {
        const cartDocRef = doc(db, 'carts', userId);
        const itemsObject = {};
        updatedItems.forEach(item => {
          if (item && item.id) {
            itemsObject[item.id] = {
              ...item,
              updatedAt: new Date()
            };
          }
        });
        await updateDoc(cartDocRef, {
          items: itemsObject,
          updatedAt: new Date()
        });
        console.log("Cart updated in Firestore after removal:", itemsObject);
        await updateDoc(cartDocRef, {
          [`items.${itemId}`]: deleteField()
        });
      } catch (error) {
        console.error('Error removing item from Firestore:', error);
      }
    }
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  // Calculate subtotal (without delivery surcharges)
  const calculateSubtotal = () => {
    if (!Array.isArray(cartItems)) {
      console.error('calculateSubtotal: cartItems is not an array:', cartItems);
      return 0;
    }
    return cartItems.reduce((total, item) => total + item.price * (item.quantity || 1), 0);
  };

  // Calculate total delivery surcharges
  const calculateTotalSurcharges = () => {
    // Removed - no delivery surcharges with normal delivery only
    return 0;
  };

  // Calculate coupon discount
  const calculateCouponDiscount = () => {
    if (!couponApplied) return 0;
    return calculateSubtotal() * 0.02; // 2% discount
  };

  // Calculate total including surcharges and discounts
  const calculateTotal = () => {
    const subtotal = calculateSubtotal();
    const surcharges = calculateTotalSurcharges();
    const couponDiscount = calculateCouponDiscount();
    return subtotal + surcharges - couponDiscount - pointsDiscountAmount;
  };

  // Format currency
  const formatCurrency = (amount) => {
    return amount.toLocaleString('en-IN', { style: 'currency', currency: 'INR' });
  };

  // Clear cart after successful order
  const clearCart = async () => {
    localStorage.removeItem('cartItems');
    setCartItems([]);
    if (userId) {
      try {
        const cartDocRef = doc(db, 'carts', userId);
        await setDoc(cartDocRef, {
          items: {},
          updatedAt: new Date()
        });
        console.log("Cart cleared in Firestore");
      } catch (error) {
        console.error('Error clearing cart from Firestore:', error);
      }
    }
    const event = new Event('cartUpdated');
    window.dispatchEvent(event);
  };

  // Handle proceed to checkout
  const handleProceedToCheckout = () => {
    // Removed time restriction check
    const token = localStorage.getItem('authToken');
    if (token) {
      navigate('/checkout');
    } else {
      navigate('/login', { state: { from: '/checkout' } });
    }
  };

  // Handle start shopping
  const handleStartShopping = () => {
    navigate('/products');
  };

  // Fix image URL
  const getImageUrl = (image) => {
    if (!image) return 'https://via.placeholder.com/100x100?text=Product';
    if (typeof image === 'string' && image.startsWith('https://firebasestorage.googleapis.com')) {
      return image;
    }
    if (image.startsWith('http')) return image;
    if (typeof image === 'object' && image.hasOwnProperty('imageUrl')) {
      return image.imageUrl;
    }
    return `/images/${image}`;
  };

  // Get delivery icon
  const getDeliveryIcon = (speed) => {
    return '🚚'; // Standard delivery icon for all
  };

  // Get delivery title
  const getDeliveryTitle = (speed) => {
    return 'Standard Delivery'; // All items use standard delivery
  };

  // Group cart items - removed grouping, all items in one list
  const groupedCartItems = () => {
    return {
      normal: Array.isArray(cartItems) ? cartItems : []
    };
  };

  // Check if there are items with non-original delivery speeds in a category
  const hasNonOriginalItems = (items) => {
    return false; // No delivery speed changes allowed
  };

  if (loading) {
    return (
      <div className="cart-loading">
        <p>Loading your cart...</p>
      </div>
    );
  }

  const handleGoBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    navigate(-1, { replace: true });
  };

  const grouped = groupedCartItems();
  const subtotal = calculateSubtotal();
  const totalSurcharges = calculateTotalSurcharges();
  const couponDiscount = calculateCouponDiscount();
  console.log("Grouped items:", grouped);
  console.log("Subtotal:", subtotal);
  console.log("Total surcharges:", totalSurcharges);
  console.log("Points discount:", pointsDiscountAmount);

  return (
    <div className="cart-container">
      <button className="go-back-btn2" onClick={handleGoBack}>
        ← Go Back
      </button>
      {cartItems.length === 0 ? (
        <div className="cart-empty">
          <div className="cart-empty-bg"></div>
          <svg
            className="cart-icon"
            width="80"
            height="80"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
          >
            <path d="M7 18c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12L8.1 13h7.45c.75 0 1.41-.41 1.75-1.03L21.7 4H5.21l-.94-2H1zm16 16c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z" />
          </svg>
          <h2 className="cart-title">Your Cart is Empty</h2>
          <p className="cart-subtitle">
            Looks like you haven't added anything to your cart yet. Let's get started!
          </p>
          <button className="cart-button1" onClick={handleStartShopping}>
            Start Shopping Now
          </button>
        </div>
      ) : (
        <div className="cart-content">
          <h2 className="cart-title">Your Cart ({cartItems.length} {cartItems.length === 1 ? 'Item' : 'Items'})</h2>
          
          {/* Unified cart items list - all items with standard delivery */}
          <div className="cart-items">
            {cartItems.map((item) => (
              <div key={item.id} className="cart-item">
                <img
                  src={getImageUrl(item.imageUrl || item.image)}
                  alt={item.name}
                  className="cart-item-image"
                  onError={(e) => {
                    console.error("Image failed to load:", item.imageUrl || item.image);
                    e.target.src = 'https://via.placeholder.com/100x100?text=Product';
                  }}
                />
                <div className="cart-item-details">
                  <h3 className="cart-item-name">{item.name}</h3>
                  <div className="cart-item-price-container">
                    <p className="cart-item-price">
                      ₹{(item.price * (item.quantity || 1)).toLocaleString('en-IN')}
                    </p>
                  </div>
                  <div className="cart-item-quantity">
                    <button
                      className="quantity-btn decrease"
                      onClick={() => decrementQuantity(item.id)}
                      aria-label="Decrease quantity"
                    >
                      -
                    </button>
                    <span className="quantity-value">{item.quantity || 1}</span>
                    <button
                      className="quantity-btn increase"
                      onClick={() => incrementQuantity(item.id)}
                      aria-label="Increase quantity"
                    >
                      +
                    </button>
                  </div>
                </div>
                <button
                  className="cart-item-remove"
                  onClick={() => removeItem(item.id)}
                >
                  Remove
                </button>
              </div>
            ))}
          </div>
          
          <div className="cart-summary">
            {/* Discounts section */}
            <div className="cart-discounts">
              <h3>Discounts & Rewards</h3>
              
              {/* Points discount */}
              {userId ? (
                <div className="discount-option">
                  <label className="discount-checkbox">
                    <input
                      type="checkbox"
                      checked={usePointsDiscount}
                      onChange={handlePointsToggle}
                      disabled={availablePoints < 100}
                    />
                    <span>
                      Use loyalty points ({availablePoints} available)
                    </span>
                  </label>
                  {usePointsDiscount && pointsMessage && (
                    <div className="points-info">
                      {pointsMessage}
                    </div>
                  )}
                  {availablePoints < 100 && (
                    <div className="insufficient-points">
                      Minimum 100 points required to redeem
                    </div>
                  )}
                </div>
              ) : (
                <div className="discount-option">
                  <button 
                    className="login-for-points-btn"
                    onClick={() => navigate('/login', { state: { from: '/cart' } })}
                  >
                    Log in to use your loyalty points
                  </button>
                </div>
              )}
            </div>
            
            <div className="cart-summary-details">
              <div className="summary-row">
                <span>Subtotal:</span>
                <span>{formatCurrency(subtotal)}</span>
              </div>
              {couponDiscount > 0 && (
                <div className="summary-row discount">
                  <span>Coupon Discount (2%):</span>
                  <span>-{formatCurrency(couponDiscount)}</span>
                </div>
              )}
              {pointsDiscountAmount > 0 && (
                <div className="summary-row points-discount">
                  <span>Points Discount:</span>
                  <span>-{formatCurrency(pointsDiscountAmount)}</span>
                </div>
              )}
              <div className="summary-row total">
                <span>Total:</span>
                <span>{formatCurrency(calculateTotal())}</span>
              </div>
            </div>
            
            <button 
              className="checkout-btn" 
              onClick={handleProceedToCheckout}
            >
              Proceed to Checkout
            </button>
            
            {orderError && (
              <div className="error-message" style={{ color: 'red', marginTop: '10px' }}>
                {orderError}
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Cart;